import { CSSProperties } from "react";
// import "./iconAnimations.scss";
interface IIconProps {
  scale?: number;
  color?: string;
  rotate?: number;
  className?: string;
  style?: CSSProperties;
  active?: boolean;
  loading?: boolean;
}

export const IllustrationAnalyticsTeam = (props: IIconProps) => {
  const { className = "", scale = 1, color = "#000", style = {} } = props;
  return (
    <svg
      viewBox="0 0 762 689.78723"
      width={`${scale * 100}px`}
      height={`${scale * 90}px`}
      style={style}
      className={className}
      fill={color}
    >
      <path
        d="M727.535,347.65423H472.69653a16.51867,16.51867,0,0,1-16.5-16.5V131.00043a12.10185,12.10185,0,0,1,12.08789-12.08838h263.4535A12.31111,12.31111,0,0,1,744.035,131.20941V331.15423A16.51866,16.51866,0,0,1,727.535,347.65423Z"
        transform="translate(-219 -105.10638)"
        fill="#f2f2f2"
      />
      <path
        d="M488.69653,331.15423H711.535a16,16,0,0,0,16-16V161.60638a16,16,0,0,0-16-16H488.69653a16,16,0,0,0-16,16V315.15423A16,16,0,0,0,488.69653,331.15423Z"
        transform="translate(-219 -105.10638)"
        fill="#fff"
      />
      <path
        d="M743.8053,130.05658H455.965v-8.40039a16.57376,16.57376,0,0,1,16.56-16.54981H727.24524a16.57369,16.57369,0,0,1,16.56006,16.54981Z"
        transform="translate(-219 -105.10638)"
        fill="#ccc"
      />
      <circle cx="267.06033" cy="12.5" r="4.28342" fill="#fff" />
      <circle cx="283.31913" cy="12.5" r="4.28342" fill="#fff" />
      <circle cx="299.57794" cy="12.5" r="4.28342" fill="#fff" />
      <path
        d="M505.09487,217.56238h-11.036a2.25988,2.25988,0,0,1-2.25737-2.25737V204.269a2.25987,2.25987,0,0,1,2.25737-2.25737h11.036a2.25988,2.25988,0,0,1,2.25737,2.25737v11.036A2.25989,2.25989,0,0,1,505.09487,217.56238Z"
        transform="translate(-219 -105.10638)"
        fill="#17376f"
      />
      <path
        d="M505.09487,246.15568h-11.036a2.25987,2.25987,0,0,1-2.25737-2.25737v-11.036a2.25987,2.25987,0,0,1,2.25737-2.25736h11.036a2.25988,2.25988,0,0,1,2.25737,2.25736v11.036A2.25988,2.25988,0,0,1,505.09487,246.15568Z"
        transform="translate(-219 -105.10638)"
        fill="#3f3d56"
      />
      <path
        d="M505.09487,274.749h-11.036a2.25987,2.25987,0,0,1-2.25737-2.25737v-11.036a2.25987,2.25987,0,0,1,2.25737-2.25737h11.036a2.25988,2.25988,0,0,1,2.25737,2.25737v11.036A2.25988,2.25988,0,0,1,505.09487,274.749Z"
        transform="translate(-219 -105.10638)"
        fill="#ccc"
      />
      <path
        d="M577.33059,212.04437H524.15707a2.25737,2.25737,0,0,1,0-4.51473h53.17352a2.25737,2.25737,0,1,1,0,4.51473Z"
        transform="translate(-219 -105.10638)"
        fill="#ccc"
      />
      <path
        d="M577.33059,240.63767H524.15707a2.25737,2.25737,0,0,1,0-4.51473h53.17352a2.25736,2.25736,0,1,1,0,4.51473Z"
        transform="translate(-219 -105.10638)"
        fill="#ccc"
      />
      <path
        d="M577.33059,269.231H524.15707a2.25737,2.25737,0,0,1,0-4.51473h53.17352a2.25737,2.25737,0,1,1,0,4.51473Z"
        transform="translate(-219 -105.10638)"
        fill="#ccc"
      />
      <path
        d="M708.34116,239.09724c.05671-.949.08892-1.90451.08892-2.86774a47.31775,47.31775,0,0,0-47.3177-47.3177v50.18544Z"
        transform="translate(-219 -105.10638)"
        fill="#17376f"
      />
      <path
        d="M657.5277,243.39885V193.21341a47.3177,47.3177,0,1,0,47.22879,50.18544Z"
        transform="translate(-219 -105.10638)"
        fill="#3f3d56"
      />
      <path
        d="M980,794.89362H220a1,1,0,0,1,0-2H980a1,1,0,0,1,0,2Z"
        transform="translate(-219 -105.10638)"
        fill="#ccc"
      />
      <path
        d="M723.69,518.032a10.70347,10.70347,0,0,1,.8898,1.43141l50.11327,5.63486,7.28838-9.84724,16.29888,9.05707L783.933,548.22754l-61.39551-16.11278A10.67269,10.67269,0,1,1,723.69,518.032Z"
        transform="translate(-219 -105.10638)"
        fill="#ffb8b8"
      />
      <path
        d="M467.98716,505.09418a10.05572,10.05572,0,0,1-14.52487-5.17531l-35.72708.745,9.8976-15.71214,32.40963,1.70135a10.11027,10.11027,0,0,1,7.94472,18.44106Z"
        transform="translate(-219 -105.10638)"
        fill="#ffb8b8"
      />
      <path
        d="M452.285,500.59644a4.509,4.509,0,0,1-4.42846,3.21337l-65.38677-1.66091-59.2065-17.52973a12.81886,12.81886,0,1,1,7.63274-24.47233l53.4904,17.53816,64.201,6.19566a4.52376,4.52376,0,0,1,4.06742,4.55554l-.18586,10.95078A4.52253,4.52253,0,0,1,452.285,500.59644Z"
        transform="translate(-219 -105.10638)"
        fill="#3f3d56"
      />
      <polygon
        points="138.461 676.601 150.72 676.6 156.553 629.312 138.459 629.313 138.461 676.601"
        fill="#ffb8b8"
      />
      <path
        d="M354.33347,777.70432l24.1438-.001h.001a15.38605,15.38605,0,0,1,15.38647,15.38623v.5l-39.53051.00146Z"
        transform="translate(-219 -105.10638)"
        fill="#2f2e41"
      />
      <polygon
        points="102.461 676.601 114.72 676.6 120.553 629.312 102.459 629.313 102.461 676.601"
        fill="#ffb8b8"
      />
      <path
        d="M318.33347,777.70432l24.1438-.001h.001a15.38605,15.38605,0,0,1,15.38647,15.38623v.5l-39.53051.00146Z"
        transform="translate(-219 -105.10638)"
        fill="#2f2e41"
      />
      <path
        d="M313.233,590.5992l2.92742,173.69393a4,4,0,0,0,4.36158,3.91617l14.34623-1.30421a4,4,0,0,0,3.62589-3.67442l8.39886-108.34524a1,1,0,0,1,1.99629.03943l4.19795,110.82575a4,4,0,0,0,3.99713,3.84859h15.38563a4,4,0,0,0,3.99255-3.756L387.233,589.5992l-64-16Z"
        transform="translate(-219 -105.10638)"
        fill="#2f2e41"
      />
      <circle cx="140.65422" cy="297.83534" r="24.56103" fill="#ffb8b8" />
      <path
        d="M386.29155,597.03866c-.02392,0-.04761-.001-.07153-.001l-57.43091-.88379a4.49951,4.49951,0,0,1-4.40845-4.05176l-.65014-6.50293a.50005.50005,0,0,0-.99512,0l-.67163,6.7168a4.49386,4.49386,0,0,1-4.13257,4.03809l-4.05859.3125a4.49944,4.49944,0,0,1-4.698-5.62793l3.49463-13.32422a181.54022,181.54022,0,0,0,1.69775-84.66016l-1.73657-7.89941a28.528,28.528,0,0,1,13.47021-30.81641l11.28028-6.6123,5.11792-7.67676a11.08482,11.08482,0,0,1,8.97754-4.92285c7.1394-.15625,19.38623,1.15137,21.68725,11.59082a28.50083,28.50083,0,0,1,19.282,27.44141l-1.65673,118.44238a4.50121,4.50121,0,0,1-4.49732,4.4375Z"
        transform="translate(-219 -105.10638)"
        fill="#3f3d56"
      />
      <path
        d="M357.733,417.0992c-.10071,3.472-2.51116,5.48066-5.47053,7.29925s-6.41876,2.60712-9.80794,3.36775a2.99863,2.99863,0,0,1-4.40516-2.62457l-3.1084-11.82324a74.84075,74.84075,0,0,1-2.39306-11.537c-.74861-7.50914,1.031-15.58706,6.27222-21.01633s14.33084-7.358,20.6116-3.17479c7.45361-9.51977,41.52344,11.513,33.11914,18.13282-1.49512,1.17767-3.78063-.31249-5.67841-.45693s-4.02454.18936-5.23,1.66218c-1.575,1.92421-.889,4.79052-1.538,7.1909a6.71433,6.71433,0,0,1-8.48369,4.34834,23.08891,23.08891,0,0,1-4.39987-2.82861c-1.45566-.96957-3.29506-1.686-4.93368-1.0745-2.15991.80607-2.92722,3.45041-3.12242,5.74756A53.23525,53.23525,0,0,1,357.733,417.0992Z"
        transform="translate(-219 -105.10638)"
        fill="#2f2e41"
      />
      <polygon
        points="144.469 377.819 148.469 426.819 169.469 477.819 138.469 427.819 144.469 377.819"
        opacity="0.2"
      />
      <path
        d="M621.8191,751.2528,402.64859,621.22607a16.51868,16.51868,0,0,1-5.77178-22.60944L499.00167,426.477a12.10185,12.10185,0,0,1,16.56391-4.22883L742.14529,556.67053a12.31111,12.31111,0,0,1,4.30147,16.85056L644.42854,745.481A16.51868,16.51868,0,0,1,621.8191,751.2528Z"
        transform="translate(-219 -105.10638)"
        fill="#f2f2f2"
      />
      <path
        d="M424.828,615.19917,616.47734,728.89848a16,16,0,0,0,21.9243-5.59688l78.345-132.05681a16,16,0,0,0-5.59688-21.9243L519.50044,455.62118a16,16,0,0,0-21.9243,5.59688l-78.345,132.05681A16,16,0,0,0,424.828,615.19917Z"
        transform="translate(-219 -105.10638)"
        fill="#fff"
      />
      <path
        d="M746.83739,572.4124,499.28409,425.54708l4.28615-7.22464a16.57377,16.57377,0,0,1,22.6865-5.784L745.32552,542.50484a16.57369,16.57369,0,0,1,5.798,22.68291Z"
        transform="translate(-219 -105.10638)"
        fill="#ccc"
      />
      <circle cx="312.5197" cy="325.08868" r="4.28342" fill="#fff" />
      <circle cx="326.50287" cy="333.38445" r="4.28342" fill="#fff" />
      <circle cx="340.48604" cy="341.68021" r="4.28342" fill="#fff" />
      <rect
        x="692.75326"
        y="596.91526"
        width="0.54603"
        height="3.27619"
        transform="translate(-394.35578 784.07411) rotate(-59.32072)"
        fill="#e6e6e6"
      />
      <path
        d="M685.786,594.57538l-5.69215-3.377.2786-.46961,5.69215,3.377Zm-11.38442-6.754-5.69216-3.377.2786-.46961,5.69216,3.377Zm-11.38443-6.754-5.69216-3.377.27861-.46961,5.69215,3.377Zm-11.38443-6.754-5.69215-3.377.2786-.46961,5.69216,3.377Zm-11.38442-6.754-5.69216-3.377.27861-.46961,5.69215,3.377Zm-11.38443-6.754-5.69215-3.377.2786-.46961,5.69216,3.377Zm-11.38442-6.754-5.69216-3.377.27861-.46961,5.69215,3.377Zm-11.38443-6.754-5.69215-3.377.2786-.46961,5.69216,3.377Zm-11.38442-6.754-5.69216-3.377.2786-.46961,5.69216,3.377Zm-11.38443-6.754-5.69215-3.377.2786-.4696,5.69215,3.377Zm-11.38442-6.754-5.69216-3.377.2786-.4696,5.69216,3.377Zm-11.38443-6.754-5.69215-3.377.2786-.4696,5.69215,3.377Zm-11.38442-6.754-5.69216-3.377.2786-.46961,5.69216,3.377Zm-11.38443-6.754-5.69227-3.377.2786-.46961,5.69227,3.377Zm-11.38443-6.754-5.69215-3.377.2786-.46961,5.69216,3.377Zm-11.38442-6.754-5.69227-3.377.2786-.46961,5.69227,3.377Z"
        transform="translate(-219 -105.10638)"
        fill="#e6e6e6"
      />
      <rect
        x="502.09266"
        y="483.80252"
        width="0.54603"
        height="3.27619"
        transform="translate(-390.45414 564.69995) rotate(-59.32072)"
        fill="#e6e6e6"
      />
      <rect
        x="574.33054"
        y="585.704"
        width="0.54603"
        height="3.27619"
        transform="translate(-442.71335 676.73529) rotate(-59.32072)"
        fill="#e6e6e6"
      />
      <path
        d="M567.44766,583.41418,561.84,580.08734l.2786-.46961,5.60766,3.32684Zm-11.21531-6.65369-5.60766-3.32684.2786-.4696,5.60766,3.32684ZM545.017,570.10681,539.40937,566.78l.27861-.46961,5.60765,3.32684Zm-11.21531-6.65368-5.60766-3.32684.2786-.46961,5.60766,3.32684Zm-11.21532-6.65368-5.60777-3.32691.2786-.46961,5.60777,3.32691ZM511.371,550.1457l-5.60766-3.32684.2786-.46961,5.60766,3.32684ZM500.15565,543.492l-5.60766-3.32684.27861-.4696,5.60765,3.32684Zm-11.21532-6.65368-5.60765-3.32684.2786-.46961,5.60766,3.32684Z"
        transform="translate(-219 -105.10638)"
        fill="#e6e6e6"
      />
      <rect
        x="476.1826"
        y="527.47601"
        width="0.54603"
        height="3.27619"
        transform="translate(-440.70488 563.80623) rotate(-59.32072)"
        fill="#e6e6e6"
      />
      <rect
        x="507.12796"
        y="573.77019"
        width="0.54603"
        height="3.27619"
        transform="translate(-465.36353 613.09379) rotate(-59.32072)"
        fill="#e6e6e6"
      />
      <path
        d="M500.08342,571.38447l-5.76943-3.42282.2786-.4696,5.76943,3.42281Zm-11.539-6.8457L482.775,561.116l.27861-.46961,5.76943,3.42281Zm-11.53886-6.84563-5.76943-3.42281.27861-.46961,5.76943,3.42281Z"
        transform="translate(-219 -105.10638)"
        fill="#e6e6e6"
      />
      <rect
        x="463.92407"
        y="548.13874"
        width="0.54603"
        height="3.27619"
        transform="translate(-464.47942 563.38339) rotate(-59.32072)"
        fill="#e6e6e6"
      />
      <rect
        x="486.20845"
        y="609.03171"
        width="0.54603"
        height="3.27619"
        transform="translate(-505.93544 612.37221) rotate(-59.32072)"
        fill="#e6e6e6"
      />
      <path
        d="M479.16391,606.646l-5.76943-3.42281.2786-.46961,5.76943,3.42281Zm-11.539-6.8457-5.76943-3.42281.2786-.46961,5.76943,3.42282Zm-11.53886-6.84563-5.76943-3.42281.2786-.46961,5.76943,3.42282Z"
        transform="translate(-219 -105.10638)"
        fill="#e6e6e6"
      />
      <rect
        x="443.00457"
        y="583.40025"
        width="0.54603"
        height="3.27619"
        transform="translate(-505.05132 562.6618) rotate(-59.32072)"
        fill="#e6e6e6"
      />
      <path
        d="M457.40154,594.22223l162.40985,96.35248a17.26548,17.26548,0,0,0,23.63179-6.03277l47.45331-79.98636-.32653-.18123L582.90466,631.8558l-8.52852-33.39355a4.1237,4.1237,0,0,0-2.3875-2.787,4.39388,4.39388,0,0,0-2.81786-.15814l-56.42137,14.39926-6.23665-24.41473a4.13956,4.13956,0,0,0-5.03644-2.988C501.09523,582.61466,464.381,592.34258,457.40154,594.22223Z"
        transform="translate(-219 -105.10638)"
        fill="#17376f"
      />
      <path
        d="M456.43081,594.28059l-.135-.529,45.14944-11.52584a4.646,4.646,0,0,1,5.64492,3.349l6.11019,23.935,56.10809-14.32339a4.646,4.646,0,0,1,5.64492,3.349l8.40225,32.91358,108.226-27.62815.135.529-108.755,27.76319-8.53729-33.44258a4.095,4.095,0,0,0-4.98086-2.955l-56.6371,14.45843-6.24524-24.46406a4.10019,4.10019,0,0,0-4.98086-2.955Z"
        transform="translate(-219 -105.10638)"
        fill="#3f3d56"
      />
      <circle cx="289.80979" cy="471.13771" r="3.82222" fill="#3f3d56" />
      <circle cx="357.01238" cy="483.07152" r="3.82222" fill="#3f3d56" />
      <circle cx="474.09156" cy="492.27639" r="3.82222" fill="#3f3d56" />
      <path
        d="M393.37946,601.9174a10.05579,10.05579,0,0,1-.31761-15.41606l-13.37856-33.136,18.20228,3.67571,9.9139,30.903a10.11027,10.11027,0,0,1-14.42,13.97336Z"
        transform="translate(-219 -105.10638)"
        fill="#ffb8b8"
      />
      <path
        d="M393.1576,587.56063a4.50906,4.50906,0,0,1-4.57608-2.99942L366.92391,522.843l-4.62838-61.57336a12.81886,12.81886,0,1,1,25.588-1.55128l2.59146,56.23251,16.99724,62.21933a4.52375,4.52375,0,0,1-2.81506,5.41961l-10.30361,3.71344A4.52237,4.52237,0,0,1,393.1576,587.56063Z"
        transform="translate(-219 -105.10638)"
        fill="#3f3d56"
      />
      <path
        d="M794.719,532.87451a4.58959,4.58959,0,0,1-1.11619-.69655l-20.14091-16.9666a4.57512,4.57512,0,0,1-.29423-6.72835l18.27677-18.35229a4.5519,4.5519,0,0,1,5.93049-.47235L811.19646,499.695a4.57786,4.57786,0,0,1,1.448,5.65826l-11.957,25.28131a4.57994,4.57994,0,0,1-5.96851,2.23991Z"
        transform="translate(-219 -105.10638)"
        fill="#17376f"
      />
      <polygon
        points="654.276 667.73 642.247 671.003 623.898 626.162 641.652 621.332 654.276 667.73"
        fill="#ffb8b8"
      />
      <path
        d="M853.29972,773.57564H877.593a0,0,0,0,1,0,0v15.13777a0,0,0,0,1,0,0H838.41287a0,0,0,0,1,0,0v-.25092A14.88686,14.88686,0,0,1,853.29972,773.57564Z"
        transform="translate(-393.98241 147.55249) rotate(-15.22067)"
        fill="#2f2e41"
      />
      <polygon
        points="551.441 676.909 538.975 676.908 533.044 628.823 551.444 628.824 551.441 676.909"
        fill="#ffb8b8"
      />
      <path
        d="M529.81942,673.346h24.29327a0,0,0,0,1,0,0v15.13777a0,0,0,0,1,0,0H514.93256a0,0,0,0,1,0,0v-.25092A14.88686,14.88686,0,0,1,529.81942,673.346Z"
        fill="#2f2e41"
      />
      <circle cx="570.22114" cy="334.4528" r="24.97498" fill="#ffb8b8" />
      <path
        d="M769.67811,747.73077h-17.036a4.58914,4.58914,0,0,1-4.57138-4.29382c-5.07632-80.69888-2.10694-138.58608,9.34458-182.17277a4.75677,4.75677,0,0,1,.18545-.56105l.91234-2.281a4.55426,4.55426,0,0,1,4.24889-2.87679h35.03255a4.56841,4.56841,0,0,1,3.47434,1.59778l4.75831,5.552c.09284.10824.17973.21846.2634.33465,21.45671,29.92172,40.68557,88.41962,62.95582,167.04706a4.5605,4.5605,0,0,1-3.00836,5.60957l-18.30834,5.85883a4.60045,4.60045,0,0,1-5.51648-2.37133l-47.51012-98.5405a3.55918,3.55918,0,0,0-6.73194,1.06353l-13.9594,102.07763A4.59333,4.59333,0,0,1,769.67811,747.73077Z"
        transform="translate(-219 -105.10638)"
        fill="#2f2e41"
      />
      <path
        d="M804.10666,563.10127c-.04791,0-.09558-.001-.14374-.002l-42.5537-1.34356a4.561,4.561,0,0,1-4.40156-4.02074c-5.39434-43.66514,9.39994-55.36293,16.011-58.36484a3.51794,3.51794,0,0,0,2.04612-2.7894l.572-4.57683a4.55913,4.55913,0,0,1,.90414-2.22238c10.36541-13.42764,24.51919-17.72742,32.03363-19.09481a4.56882,4.56882,0,0,1,5.33973,3.91449l.857,6.57181a3.62041,3.62041,0,0,0,.7254,1.71992c21.61733,28.26039-2.46543,69.98715-7.51271,78.06439h0A4.58439,4.58439,0,0,1,804.10666,563.10127Z"
        transform="translate(-219 -105.10638)"
        fill="#17376f"
      />
      <path
        d="M816.7,424.02666a103.57206,103.57206,0,0,1-4.09287-17.25254c-.273-3.41006.60057-7.07923,3.08395-9.43206,4.64755-4.40323,12.54378-2.306,17.40406,1.86121,7.02423,6.02258,10.52747,15.27806,11.85143,24.43548s.74144,18.46957,1.06013,27.71671,1.64124,18.75534,6.35559,26.71687,13.46275,14.07278,22.69054,13.39517a15.969,15.969,0,0,0,9.9964-4.23637,11.591,11.591,0,0,0,3.48119-10.06508c4.71642,8.44535,2.32556,19.89152-4.70938,26.53065s-17.856,8.51593-27.10448,5.68134-16.86021-9.94222-21.4068-18.4802-6.2127-18.40091-5.97125-28.071c.18542-7.42586,1.4477-14.91251.19284-22.23392s-5.837-14.75531-13.0623-16.4794Z"
        transform="translate(-219 -105.10638)"
        fill="#2f2e41"
      />
      <path
        d="M784.25282,433.65235c-1.23189,4.11515-5.94388,6.65267-10.18271,5.95671a11.94052,11.94052,0,0,1-9.01247-8.28474,17.05556,17.05556,0,0,1,1.3329-12.50345,19.47082,19.47082,0,0,1,11.14084-9.92334,15.98674,15.98674,0,0,1,14.53656,2.32276,5.3461,5.3461,0,0,1,3.736-3.907,10.21608,10.21608,0,0,1,5.60645.08275,23.10023,23.10023,0,0,1,12.857,9.35333A37.59027,37.59027,0,0,1,820.0944,431.77c1.43448,8.05189.90537,16.85038-3.61682,23.6651s-13.774,10.83861-21.27971,7.58968c-.468-2.39261.6407-4.80178,1.92341-6.875s2.80291-4.09289,3.29567-6.48052-.45191-5.30818-2.76144-6.089c-1.9703-.66614-4.071.4131-6.14677.54342a6.73548,6.73548,0,0,1-6.461-9.70517Z"
        transform="translate(-219 -105.10638)"
        fill="#2f2e41"
      />
      <path
        d="M720.95558,536.53977a10.7034,10.7034,0,0,1,1.14367,1.238l50.27705-3.9129,5.30143-11.04461,17.714,5.82223-9.58111,26.19523-63.33219-4.25038a10.67269,10.67269,0,1,1-1.52285-14.04759Z"
        transform="translate(-219 -105.10638)"
        fill="#ffb8b8"
      />
      <path
        d="M795.11921,546.09046a4.58982,4.58982,0,0,1-1.2007-.53793L771.65332,531.489a4.57513,4.57513,0,0,1-1.20841-6.62549l15.60522-20.6718a4.5519,4.5519,0,0,1,5.81079-1.27615l15.06041,8.05944a4.57784,4.57784,0,0,1,2.20564,5.40813l-8.40018,26.67494a4.57994,4.57994,0,0,1-5.60758,3.03239Z"
        transform="translate(-219 -105.10638)"
        fill="#17376f"
      />
    </svg>
  );
};

export const IllustrationDataChart = (props: IIconProps) => {
  const { className = "", scale = 1, color = "#000", style = {} } = props;
  return (
    <svg
      viewBox="0 0 995 697.68102"
      width={`${scale * 100}px`}
      height={`${scale * 70}px`}
      style={style}
      className={className}
      fill={color}
    >
      <path
        d="M915.18858,538.70734H274.35008a16.51866,16.51866,0,0,1-16.5-16.5V127.05353A12.10185,12.10185,0,0,1,269.938,114.96515H919.39146a12.31113,12.31113,0,0,1,12.29712,12.29737V522.20734A16.51867,16.51867,0,0,1,915.18858,538.70734Z"
        transform="translate(-102.5 -101.15949)"
        fill="#f2f2f2"
      />
      <path
        d="M891.81129,515.34051H294.56654c-8.755,0-15.87756-6.66992-15.87756-14.86816v-344.105c0-6.08007,5.27795-11.02685,11.76562-11.02685H895.72828c6.59522,0,11.9607,5.02832,11.9607,11.2085V500.47235C907.689,508.67059,900.56617,515.34051,891.81129,515.34051Z"
        transform="translate(-102.5 -101.15949)"
        fill="#fff"
      />
      <path
        d="M931.45884,126.10969H257.61851V117.7093a16.57377,16.57377,0,0,1,16.56006-16.54981H914.89878a16.57369,16.57369,0,0,1,16.56006,16.54981Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
      <circle cx="185.21387" cy="12.5" r="4.28342" fill="#fff" />
      <circle cx="201.47268" cy="12.5" r="4.28342" fill="#fff" />
      <circle cx="217.73148" cy="12.5" r="4.28342" fill="#fff" />
      <path
        d="M826.07277,457.6286H363.23426a17.5199,17.5199,0,0,1-17.5-17.5V216.97479a13.10307,13.10307,0,0,1,13.0879-13.08838H830.27565a13.31242,13.31242,0,0,1,13.29712,13.29736V440.1286A17.51982,17.51982,0,0,1,826.07277,457.6286ZM358.82216,205.88641a11.10062,11.10062,0,0,0-11.0879,11.08838V440.1286a15.51745,15.51745,0,0,0,15.5,15.5H826.07277a15.51753,15.51753,0,0,0,15.5-15.5V217.18377a11.31,11.31,0,0,0-11.29712-11.29736Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
      <path
        d="M379.23429,440.1286h430.8385a16,16,0,0,0,16-16V237.58075a16,16,0,0,0-16-16H379.23429a16,16,0,0,0-16,16V424.1286A16,16,0,0,0,379.23429,440.1286Z"
        transform="translate(-102.5 -101.15949)"
        fill="#f2f2f2"
      />
      <circle cx="325.65354" cy="165.69519" r="9" fill="#ccc" />
      <circle cx="325.65354" cy="199.69519" r="9" fill="#ccc" />
      <circle cx="325.65354" cy="233.69519" r="9" fill="#ccc" />
      <circle cx="325.65354" cy="267.69519" r="9" fill="#ccc" />
      <path
        d="M769.15354,267.85468h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
      <path
        d="M769.15354,301.85468h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
      <path
        d="M769.15354,335.85468h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
      <path
        d="M769.15354,369.85468h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
      <path
        d="M529.15354,403.85468h-29a5.00582,5.00582,0,0,1-5-5v-27a5.00581,5.00581,0,0,1,5-5h29a5.0058,5.0058,0,0,1,5,5v27A5.00581,5.00581,0,0,1,529.15354,403.85468Z"
        transform="translate(-102.5 -101.15949)"
        fill="#17376f"
      />
      <path
        d="M594.15354,403.85468h-29a5.00573,5.00573,0,0,1-5-5v-61a5.00573,5.00573,0,0,1,5-5h29a5.00573,5.00573,0,0,1,5,5v61A5.00573,5.00573,0,0,1,594.15354,403.85468Z"
        transform="translate(-102.5 -101.15949)"
        fill="#17376f"
      />
      <path
        d="M660.15354,403.85468h-29a5.00573,5.00573,0,0,1-5-5v-95a5.00573,5.00573,0,0,1,5-5h29a5.00573,5.00573,0,0,1,5,5v95A5.00573,5.00573,0,0,1,660.15354,403.85468Z"
        transform="translate(-102.5 -101.15949)"
        fill="#17376f"
      />
      <path
        d="M728.15354,403.85468h-29a5.00573,5.00573,0,0,1-5-5v-128a5.00573,5.00573,0,0,1,5-5h29a5.00573,5.00573,0,0,1,5,5v128A5.00573,5.00573,0,0,1,728.15354,403.85468Z"
        transform="translate(-102.5 -101.15949)"
        fill="#17376f"
      />
      <path
        d="M769.15354,403.85468h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z"
        transform="translate(-102.5 -101.15949)"
        fill="#3f3d56"
      />
      <path
        d="M899.20129,590.40229a10.05578,10.05578,0,0,1,15.32045-1.74338l31.75518-16.38865-1.97486,18.46439L914.44957,603.4668a10.11027,10.11027,0,0,1-15.24828-13.06451Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ffb8b8"
      />
      <path
        d="M926.52427,597.2886a4.50558,4.50558,0,0,1-1.52363-2.21154l-2.52573-8.15935a4.51467,4.51467,0,0,1,1.58686-4.92123l25.73769-19.44037,27.87506-51.71229a14.49652,14.49652,0,1,1,22.9,17.78163L984.716,562.0959a46.37352,46.37352,0,0,1-23.463,22.69646l-30.16279,13.0827a4.505,4.505,0,0,1-3.66895-.0393A4.4547,4.4547,0,0,1,926.52427,597.2886Z"
        transform="translate(-102.5 -101.15949)"
        fill="#3f3d56"
      />
      <circle cx="898.77529" cy="363.5412" r="24.56103" fill="#ffb8b8" />
      <polygon
        points="888.812 685.737 876.553 685.736 870.722 638.448 888.817 638.449 888.812 685.737"
        fill="#ffb8b8"
      />
      <path
        d="M867.79529,682.2327h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H852.90843a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,867.79529,682.2327Z"
        fill="#2f2e41"
      />
      <polygon
        points="928.812 685.739 916.553 685.738 910.722 638.449 928.817 638.451 928.812 685.739"
        fill="#ffb8b8"
      />
      <path
        d="M907.79529,682.23452h23.64387a0,0,0,0,1,0,0V697.1214a0,0,0,0,1,0,0H892.90843a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,907.79529,682.23452Z"
        fill="#2f2e41"
      />
      <path
        d="M1032.208,774.899l-14.36695-.00066a4.50773,4.50773,0,0,1-4.34457-3.3293l-20.67961-76.70114a.50006.50006,0,0,0-.98194.16011l4.17735,72.74238a4.4992,4.4992,0,0,1-4.86667,4.742L974.998,771.16588a4.51234,4.51234,0,0,1-4.096-3.96406L956.19143,614.457l5.69125,3.4153,53.329-9.05421L1036.669,769.80443a4.50072,4.50072,0,0,1-4.46092,5.09453Z"
        transform="translate(-102.5 -101.15949)"
        fill="#2f2e41"
      />
      <path
        d="M974.02688,630.57892a32.93909,32.93909,0,0,1-16.69168-4.698,4.48018,4.48018,0,0,1-2.13627-4.589c1.87553-11.48624,11.68388-70.40767,20.608-102.52933,3.63463-13.08284,11.67132-20.12935,23.88694-20.94324,17.868-1.172,33.7499,12.8072,35.4036,31.19985,2.91747,32.44838-8.93327,78.55038-14.16384,96.86557a4.49612,4.49612,0,0,1-7.08751,2.30632l-10.66149-8.29346a3.53283,3.53283,0,0,0-4.51612.18827C989.68227,628.10112,981.146,630.57924,974.02688,630.57892Z"
        transform="translate(-102.5 -101.15949)"
        fill="#3f3d56"
      />
      <polygon
        points="906.787 443.738 915.786 481.739 902.784 513.738 911.786 482.739 906.787 443.738"
        opacity="0.2"
      />
      <path
        d="M1015.29012,484.89818a16.53845,16.53845,0,0,0,6.388-1.15546c.89413-.34453,1.82229-.6277,2.71475-.97246,7.88184-3.04473,13.07419-11.43846,13.26053-19.88589s-4.18791-16.64664-10.68362-22.05029-14.90949-8.17814-23.33455-8.82c-9.07519-.69142-19.29429,1.60955-24.36577,9.16714-1.34994,2.01171-2.29409,4.45248-1.49436,6.88154a4.40355,4.40355,0,0,0,1.24071,1.906c2.26461,2.015,4.52247.50009,6.83114.36634,3.17326-.18383,6.02327,2.38485,7.04751,5.39387s.57317,6.32164-.25409,9.39067a23.459,23.459,0,0,0-1.18275,5.71,5.74055,5.74055,0,0,0,2.37833,5.05482c1.98283,1.19867,4.5869.5051,6.571-.69146s3.69854-2.8603,5.84171-3.74078,5.02247-.685,6.26978,1.26757a6.93469,6.93469,0,0,1,.79255,2.28865c1.11805,5.0949.86105,4.79484,1.97909,9.88974Z"
        transform="translate(-102.5 -101.15949)"
        fill="#2f2e41"
      />
      <path
        d="M977.22128,752.59121,823.42537,699.0304a10.55633,10.55633,0,0,1-6.48991-13.42571l39.96568-114.75847a7.73373,7.73373,0,0,1,9.83576-4.7548L1025.732,621.46289a7.86747,7.86747,0,0,1,4.83675,10.006L990.647,746.1013A10.55633,10.55633,0,0,1,977.22128,752.59121Z"
        transform="translate(-102.5 -101.15949)"
        fill="#e6e6e6"
      />
      <path
        d="M836.54932,692.4354l134.4838,46.83519a10.22487,10.22487,0,0,0,13.01887-6.29324l32.272-92.66666a10.22487,10.22487,0,0,0-6.29325-13.01886l-134.4838-46.8352a10.22488,10.22488,0,0,0-13.01887,6.29325l-32.272,92.66666A10.22486,10.22486,0,0,0,836.54932,692.4354Z"
        transform="translate(-102.5 -101.15949)"
        fill="#fff"
      />
      <path
        d="M870.32,627.32885l-6.66027-2.3195a1.44418,1.44418,0,0,1-.88788-1.83677l2.3195-6.66027a1.44418,1.44418,0,0,1,1.83677-.88789l6.66027,2.3195a1.44418,1.44418,0,0,1,.88788,1.83677l-2.3195,6.66027A1.44417,1.44417,0,0,1,870.32,627.32885Z"
        transform="translate(-102.5 -101.15949)"
        fill="#17376f"
      />
      <path
        d="M864.31039,644.585l-6.66027-2.3195a1.44418,1.44418,0,0,1-.88789-1.83677l2.3195-6.66027a1.44418,1.44418,0,0,1,1.83677-.88789l6.66028,2.3195a1.44418,1.44418,0,0,1,.88788,1.83677l-2.3195,6.66027A1.44419,1.44419,0,0,1,864.31039,644.585Z"
        transform="translate(-102.5 -101.15949)"
        fill="#3f3d56"
      />
      <path
        d="M858.30078,661.84117l-6.66027-2.3195a1.44418,1.44418,0,0,1-.88789-1.83677l2.3195-6.66028a1.44418,1.44418,0,0,1,1.83677-.88788l6.66027,2.3195a1.44418,1.44418,0,0,1,.88789,1.83677l-2.3195,6.66027A1.44419,1.44419,0,0,1,858.30078,661.84117Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
      <path
        d="M915.07426,639.18089l-32.0904-11.17577a1.44258,1.44258,0,1,1,.94888-2.72465l32.0904,11.17577a1.44258,1.44258,0,1,1-.94888,2.72465Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
      <path
        d="M909.06464,656.43705l-32.0904-11.17577a1.44258,1.44258,0,0,1,.94889-2.72466l32.0904,11.17578a1.44258,1.44258,0,1,1-.94889,2.72465Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
      <path
        d="M903.055,673.69321l-32.0904-11.17577a1.44258,1.44258,0,0,1,.94889-2.72466l32.0904,11.17577a1.44258,1.44258,0,0,1-.94889,2.72466Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
      <path
        d="M988.45374,683.04261c.23367-.56078.45394-1.13069.65639-1.712a30.23861,30.23861,0,0,0-18.61138-38.50142L959.951,673.11628Z"
        transform="translate(-102.5 -101.15949)"
        fill="#17376f"
      />
      <path
        d="M956.88355,674.9589l10.54775-30.28708a30.23857,30.23857,0,1,0,17.955,40.21342Z"
        transform="translate(-102.5 -101.15949)"
        fill="#3f3d56"
      />
      <path
        d="M994.645,631.51231a10.05576,10.05576,0,0,1,10.9793-10.8264l14.87332-32.49251,9.84082,15.74776-15.63267,28.44114a10.11027,10.11027,0,0,1-20.06077-.87Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ffb8b8"
      />
      <path
        d="M1020.3943,620.06931a4.50557,4.50557,0,0,1-2.56368-.79992l-7.02273-4.86165a4.51467,4.51467,0,0,1-1.78835-4.85164l8.25508-31.18029-9.9788-57.893a14.49652,14.49652,0,1,1,28.99268-.14028l8.17682,36.12342a46.37349,46.37349,0,0,1-4.45582,32.33866L1024.349,617.713a4.505,4.505,0,0,1-2.91123,2.23327A4.4546,4.4546,0,0,1,1020.3943,620.06931Z"
        transform="translate(-102.5 -101.15949)"
        fill="#3f3d56"
      />
      <path
        d="M1096.5,798.84051h-190a1,1,0,0,1,0-2h190a1,1,0,0,1,0,2Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
      <polygon
        points="490.541 685.239 502.801 685.238 508.633 637.951 490.539 637.951 490.541 685.239"
        fill="#a0616a"
      />
      <path
        d="M589.914,782.39593l24.14379-.001h.001a15.38605,15.38605,0,0,1,15.38648,15.38623v.5l-39.53052.00147Z"
        transform="translate(-102.5 -101.15949)"
        fill="#2f2e41"
      />
      <polygon
        points="441.541 685.239 453.801 685.238 459.633 637.951 441.539 637.951 441.541 685.239"
        fill="#a0616a"
      />
      <path
        d="M540.914,782.39593l24.14379-.001h.001a15.38605,15.38605,0,0,1,15.38648,15.38623v.5l-39.53052.00147Z"
        transform="translate(-102.5 -101.15949)"
        fill="#2f2e41"
      />
      <circle cx="492.98819" cy="333.297" r="24.56103" fill="#a0616a" />
      <path
        d="M612.00462,776.19239H589.25389a4.50027,4.50027,0,0,1-4.49952-4.55469l1.322-108.03125a1.50006,1.50006,0,0,0-2.989-.20019L569.84666,772.23634a4.50405,4.50405,0,0,1-4.467,3.95605H542.41038a4.49963,4.49963,0,0,1-4.48633-4.85058l15.16748-194.0752.41236-.04492,72.6289-7.84375-9.63306,202.52832A4.49485,4.49485,0,0,1,612.00462,776.19239Z"
        transform="translate(-102.5 -101.15949)"
        fill="#2f2e41"
      />
      <path
        d="M553.97556,589.18067a4.49625,4.49625,0,0,1-4.48388-4.3584c-.39649-12.27148-1.07593-54.73242,6.822-85.90527a40.92362,40.92362,0,0,1,37.79272-30.83887h0a41.17944,41.17944,0,0,1,40.5586,26.02344c13.27539,33.70313,25.81787,75.24609,10.18091,81.76172-20.49488,8.53906-74.52344,12.3457-90.59424,13.30859Q554.1129,589.18067,553.97556,589.18067Z"
        transform="translate(-102.5 -101.15949)"
        fill="#3f3d56"
      />
      <path
        d="M647.84686,409.63245a10.525,10.525,0,0,0,1.24595,1.09311l-2.57824,49.52618-10.72422,5.49051L641.96113,483.01l19.92972-7.87486a8,8,0,0,0,5.0258-8.18055l-5.22116-56.17946a10.4971,10.4971,0,1,0-13.84863-1.14269Z"
        transform="translate(-102.5 -101.15949)"
        fill="#a0616a"
      />
      <path
        d="M646.71807,462.09529l7.54416,21.4389a4.5,4.5,0,0,1-3.38906,5.91156l-22.24542,4.30783a12.49741,12.49741,0,0,1-8.22761-23.60176l19.97367-10.543a4.5,4.5,0,0,1,6.34426,2.48649Z"
        transform="translate(-102.5 -101.15949)"
        fill="#3f3d56"
      />
      <path
        d="M541.46023,409.63245a10.52654,10.52654,0,0,1-1.24595,1.09311l2.57824,49.52618,10.72421,5.49051L547.346,483.01l-19.92971-7.87486a8,8,0,0,1-5.0258-8.18055l5.22116-56.17946a10.4971,10.4971,0,1,1,13.84863-1.14269Z"
        transform="translate(-102.5 -101.15949)"
        fill="#a0616a"
      />
      <path
        d="M545.19208,459.39926a4.4952,4.4952,0,0,1,3.7412.20954l19.97367,10.543a12.49741,12.49741,0,0,1-8.22761,23.60176l-22.24543-4.30783a4.5,4.5,0,0,1-3.38906-5.91156l7.54417-21.4389A4.495,4.495,0,0,1,545.19208,459.39926Z"
        transform="translate(-102.5 -101.15949)"
        fill="#3f3d56"
      />
      <path
        d="M605.02743,438.64306a16.14328,16.14328,0,0,1,9.04058-15.16765c7.46588-3.85407,12.156-12.07515,10.10082-19.58209-2.63064-9.60889-15.70861-15.84073-26.30516-12.53479a48.56567,48.56567,0,0,0-8.26083,3.83932l-6.9231,3.711a71.73,71.73,0,0,0-8.534,5.03785,28.31535,28.31535,0,0,0-11.27028,26.53c1.36336,9.76869,7.76069,18.72744,16.51765,24.861a27.93653,27.93653,0,0,0,11.3188,5.03108c4.19751.69206,8.87033-.09445,11.93939-2.70479,4.79626-4.07937,4.30076-10.91072,2.74952-16.61635A12.09016,12.09016,0,0,1,605.02743,438.64306Z"
        transform="translate(-102.5 -101.15949)"
        fill="#2f2e41"
      />
      <path
        d="M688.5,798.84051h-190a1,1,0,0,1,0-2h190a1,1,0,0,1,0,2Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
      <path
        d="M378.4097,616.413,221.63255,680.73031a10.98425,10.98425,0,0,1-14.31518-5.98649l-47.9919-116.983a8.04723,8.04723,0,0,1,4.38557-10.48759l162.0771-66.49162a8.1864,8.1864,0,0,1,10.66888,4.46176L384.39618,602.0978A10.98426,10.98426,0,0,1,378.4097,616.413Z"
        transform="translate(-102.5 -101.15949)"
        fill="#e6e6e6"
      />
      <path
        d="M227.31143,666.54132l137.09069-56.241a10.63937,10.63937,0,0,0,5.80508-13.88139L331.45407,501.956a10.63935,10.63935,0,0,0-13.88138-5.80507L180.482,552.39192a10.63934,10.63934,0,0,0-5.80507,13.88138l38.75312,94.46294A10.63935,10.63935,0,0,0,227.31143,666.54132Z"
        transform="translate(-102.5 -101.15949)"
        fill="#fff"
      />
      <rect
        x="328.66842"
        y="528.1173"
        width="2.17853"
        height="0.36309"
        transform="translate(-278.3402 63.53163) rotate(-22.30577)"
        fill="#e6e6e6"
      />
      <path
        d="M324.74712,530.55065l-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34085-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34086-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34085-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34086-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34085-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34086-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34085-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34086-4.07172,1.67041-.13781-.33592,4.07172-1.67041Zm-8.14351,3.34085-4.07172,1.67041-.13781-.33592,4.07172-1.67041ZM243.312,563.9592l-4.07172,1.67041-.13781-.33592,4.07172-1.67041Zm-8.14351,3.34085-4.07172,1.67041-.13781-.33592,4.07172-1.67041Zm-8.14351,3.34086-4.07172,1.67041-.13781-.33592,4.07172-1.67041Zm-8.14351,3.34085-4.0718,1.67045-.13781-.33592,4.0718-1.67045Zm-8.14351,3.34086-4.07172,1.67041-.13781-.33592,4.07172-1.67041Zm-8.14351,3.34085-4.0718,1.67045-.13781-.33592,4.0718-1.67045Z"
        transform="translate(-102.5 -101.15949)"
        fill="#e6e6e6"
      />
      <rect
        x="192.28502"
        y="584.06825"
        width="2.17853"
        height="0.36309"
        transform="translate(-309.78171 15.95413) rotate(-22.30577)"
        fill="#e6e6e6"
      />
      <rect
        x="275.30859"
        y="586.50645"
        width="2.17853"
        height="0.36309"
        transform="translate(-304.4946 47.64812) rotate(-22.30577)"
        fill="#e6e6e6"
      />
      <path
        d="M271.44765,588.915l-4.01127,1.64562-.13781-.33592,4.01127-1.64562Zm-8.02254,3.29123-4.01127,1.64561-.13781-.33592,4.01127-1.64561Zm-8.02254,3.29123-4.01127,1.64561-.13782-.33592,4.01128-1.64561ZM247.38,598.78872l-4.01127,1.64561-.13781-.33592,4.01127-1.64561ZM239.35748,602.08l-4.01135,1.64564-.13781-.33592,4.01135-1.64564Zm-8.02263,3.29126-4.01127,1.64561-.13781-.33592,4.01127-1.64561Zm-8.02254,3.29123-4.01127,1.64561-.13781-.33592,4.01127-1.64561Zm-8.02254,3.29123-4.01127,1.64561-.13781-.33592,4.01127-1.64561Z"
        transform="translate(-102.5 -101.15949)"
        fill="#e6e6e6"
      />
      <rect
        x="205.10138"
        y="615.30879"
        width="2.17853"
        height="0.36309"
        transform="translate(-320.68001 23.15625) rotate(-22.30577)"
        fill="#e6e6e6"
      />
      <rect
        x="242.06964"
        y="617.41071"
        width="2.17853"
        height="0.36309"
        transform="translate(-318.71151 37.34481) rotate(-22.30577)"
        fill="#e6e6e6"
      />
      <path
        d="M238.09306,619.86673l-4.127,1.69309-.13781-.33592,4.127-1.69308Zm-8.25406,3.38621-4.127,1.69309-.13781-.33592,4.127-1.69309Zm-8.254,3.38618-4.127,1.69309-.13781-.33592,4.127-1.69309Z"
        transform="translate(-102.5 -101.15949)"
        fill="#e6e6e6"
      />
      <rect
        x="211.16503"
        y="630.08925"
        width="2.17853"
        height="0.36309"
        transform="translate(-325.83619 26.5637) rotate(-22.30577)"
        fill="#e6e6e6"
      />
      <rect
        x="252.41742"
        y="642.63399"
        width="2.17853"
        height="0.36309"
        transform="translate(-327.51068 43.15973) rotate(-22.30577)"
        fill="#e6e6e6"
      />
      <path
        d="M248.44085,645.09l-4.127,1.69309-.13781-.33592,4.127-1.69309Zm-8.25406,3.38621-4.127,1.69309-.13781-.33592,4.127-1.69309Zm-8.254,3.38617-4.127,1.69309-.13781-.33592,4.127-1.69309Z"
        transform="translate(-102.5 -101.15949)"
        fill="#e6e6e6"
      />
      <rect
        x="221.51281"
        y="655.31253"
        width="2.17853"
        height="0.36309"
        transform="translate(-334.63536 32.37862) rotate(-22.30577)"
        fill="#e6e6e6"
      />
      <path
        d="M233.13244,651.67138,349.3075,604.01085a11.48086,11.48086,0,0,0,6.25718-14.96249L332.092,531.83249l-.22694.10082-28.50928,68.167-21.14465-8.83989a2.7421,2.7421,0,0,0-2.43553.152,2.92176,2.92176,0,0,0-1.212,1.43285l-14.9413,35.7216-15.45982-6.46235a2.75263,2.75263,0,0,0-3.60267,1.478C244.46085,623.82519,234.92848,647.2131,233.13244,651.67138Z"
        transform="translate(-102.5 -101.15949)"
        fill="#17376f"
      />
      <path
        d="M232.77482,652.21015l-.33494-.14007,11.95457-28.58641a3.08942,3.08942,0,0,1,4.03793-1.65654l15.1545,6.33747,14.85618-35.52489a3.08941,3.08941,0,0,1,4.03792-1.65655l20.83926,8.71479,28.65584-68.52337.33494.14007L303.51512,600.173l-21.17421-8.85486a2.723,2.723,0,0,0-3.56291,1.46168l-14.99625,35.85983-15.48944-6.47754a2.72646,2.72646,0,0,0-3.56291,1.46167Z"
        transform="translate(-102.5 -101.15949)"
        fill="#3f3d56"
      />
      <circle cx="141.66667" cy="516.01934" r="2.54162" fill="#3f3d56" />
      <circle cx="174.90562" cy="485.11507" r="2.54162" fill="#3f3d56" />
      <circle cx="226.6623" cy="426.63608" r="2.54162" fill="#3f3d56" />
      <path
        d="M186.9011,614.29488a10.09493,10.09493,0,0,0,3.60992-15.05255l7.5486-73.80428h-16.3133l-5.99906,72.06608a10.14964,10.14964,0,0,0,11.15384,16.79075Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ffb8b8"
      />
      <circle cx="99.37963" cy="360.46758" r="23.08006" fill="#ffb8b8" />
      <path
        d="M206.22469,568.41934a4.221,4.221,0,0,1-4.06806-3.09992c-1.84912-6.71832-6.66005-18.07734-14.29881-33.76321a27.96723,27.96723,0,0,1,15.8818-38.61269h0a27.95458,27.95458,0,0,1,35.92183,17.808c5.92086,18.56279,5.635,38.447,5.23719,46.13351a4.239,4.239,0,0,1-3.32085,3.9139l-34.4462,7.52221A4.20772,4.20772,0,0,1,206.22469,568.41934Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ff6584"
      />
      <polygon
        points="137.082 686.425 148.602 686.425 154.083 641.988 137.08 641.989 137.082 686.425"
        fill="#ffb8b8"
      />
      <path
        d="M237.11328,784.29259H273.3207a0,0,0,0,1,0,0v13.98923a0,0,0,0,1,0,0H251.10251a13.98923,13.98923,0,0,1-13.98923-13.98923v0a0,0,0,0,1,0,0Z"
        transform="translate(407.97009 1481.40327) rotate(179.99738)"
        fill="#2f2e41"
      />
      <polygon
        points="21.882 671.495 31.978 677.045 58.19 640.747 43.291 632.555 21.882 671.495"
        fill="#ffb8b8"
      />
      <path
        d="M118.19573,776.43687h36.20742a0,0,0,0,1,0,0V790.4261a0,0,0,0,1,0,0h-22.2182a13.98922,13.98922,0,0,1-13.98922-13.98922v0a0,0,0,0,1,0,0Z"
        transform="translate(-224.19403 1434.45667) rotate(-151.19904)"
        fill="#2f2e41"
      />
      <path
        d="M239.04362,762.92032a4.22817,4.22817,0,0,1-4.18943-3.68448L220.44641,648.21146a2.34928,2.34928,0,0,0-4.387-.83233L156.0137,756.31946a4.25173,4.25173,0,0,1-5.20851,1.91152L137.717,753.24432a4.2283,4.2283,0,0,1-2.41119-5.54553L176.901,645.51807a3.25729,3.25729,0,0,0,.21244-.80939c5.63385-43.60531,19.96822-65.78009,24.22716-71.5376a3.27464,3.27464,0,0,0,.466-2.98154l-.58548-1.75643a4.22648,4.22648,0,0,1,.81376-4.113c15.34656-17.47993,42.095-7.94158,42.36346-7.84339l.134.04955.084.11471c29.99294,41.13309,18.90348,174.73235,16.376,201.09633a4.21706,4.21706,0,0,1-3.88476,3.80561l-17.73551,1.36551C239.2618,762.91664,239.15236,762.92032,239.04362,762.92032Z"
        transform="translate(-102.5 -101.15949)"
        fill="#2f2e41"
      />
      <path
        d="M291.60621,488.437a9.89229,9.89229,0,0,0-.22487,1.54123l-40.36722,23.2877-9.81182-5.6485-10.46,13.69361,16.39813,11.68759a7.51761,7.51761,0,0,0,9.01944-.21974l41.62555-32.83868a9.86415,9.86415,0,1,0-6.17923-11.50321Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ffb8b8"
      />
      <path
        d="M249.6646,514.36888l-13.04658,16.909a4.22868,4.22868,0,0,1-6.39366.3502L215.45475,516.291a11.74385,11.74385,0,0,1,14.40248-18.55361l18.52432,10.35814a4.22869,4.22869,0,0,1,1.28305,6.27338Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ff6584"
      />
      <path
        d="M199.09786,543.74606l-21.01724-3.795a4.22868,4.22868,0,0,1-3.255-5.51424L181.639,514.2639a11.74385,11.74385,0,0,1,23.1015,4.24132l-.66475,21.21319a4.2287,4.2287,0,0,1-4.97792,4.02765Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ff6584"
      />
      <path
        d="M205.53264,456.31837c5.93207,4.06,13.721,8.23343,19.77971,3.90987a11.02532,11.02532,0,0,0,3.61842-12.70935c-2.9011-8.29622-10.87182-11.94861-18.49383-14.74824-9.90861-3.63952-20.69763-6.53492-30.92666-3.92847s-19.26917,12.51018-17.42263,22.90329c1.48494,8.35793,9.36882,15.31239,8.24961,23.7271-1.1264,8.46874-10.65039,12.92645-19.05857,14.44s-17.81712,1.99988-23.85974,8.03934c-7.70847,7.70443-5.78353,21.47525,1.46982,29.60959s18.19907,11.82157,28.80546,14.32819c14.05282,3.32112,29.252,5.0665,42.59867-.44522s23.73281-20.34863,19.8665-34.26132c-1.63312-5.87671-5.48026-10.84332-9.19832-15.67848s-7.48294-9.89132-8.90121-15.82354c-1.18189-4.94351-.30712-10.68318,2.97117-14.39139a4.16949,4.16949,0,0,0,.55855-4.8737Z"
        transform="translate(-102.5 -101.15949)"
        fill="#2f2e41"
      />
      <path
        d="M293.5,798.84051h-190a1,1,0,0,1,0-2h190a1,1,0,0,1,0,2Z"
        transform="translate(-102.5 -101.15949)"
        fill="#ccc"
      />
    </svg>
  );
};

export const IllustrationFinancialChart = (props: IIconProps) => {
  const { className = "", scale = 1, color = "#000", style = {} } = props;

  return (
    <svg
      width={`${scale * 100}px`}
      height={`${scale * 70}px`}
      viewBox="0 0 799.031 618.112"
      style={style}
      className={className}
      fill={color}
    >
      <g transform="translate(-560 -231.001)">
        <path
          d="M15.18,488.763c0,.872.478,1.573,1.073,1.573h535.1c.6,0,1.073-.7,1.073-1.573s-.478-1.573-1.073-1.573H16.253C15.658,487.191,15.18,487.891,15.18,488.763Z"
          transform="translate(675.479 358.777)"
          fill="#ccc"
        />
        <rect
          width="19.105"
          height="3.371"
          transform="translate(865.162 842.355)"
          fill="#b6b3c5"
        />
        <rect
          width="19.105"
          height="3.371"
          transform="translate(1034.295 842.918)"
          fill="#b6b3c5"
        />
        <path
          d="M352.955,370.945a27.529,27.529,0,0,1-54.321,0H229.146V521.536h193.3V370.945H352.955Z"
          transform="translate(633.721 321.379)"
          fill="#d6d6e3"
        />
        <rect
          width="193.296"
          height="5.242"
          transform="translate(863.43 830.984)"
          fill="#090814"
        />
        <path
          d="M788.255,487.17H10.776A10.788,10.788,0,0,1,0,476.394V32.688A10.788,10.788,0,0,1,10.776,21.911H788.255a10.789,10.789,0,0,1,10.776,10.776V476.394a10.789,10.789,0,0,1-10.776,10.776Z"
          transform="translate(560 209.09)"
          fill="#090814"
        />
        <rect
          width="760.822"
          height="429.297"
          transform="translate(580 249)"
          fill="#fff"
        />
        <g transform="translate(0 15.111)">
          <rect
            width="22.297"
            height="6.768"
            rx="3.384"
            transform="translate(651.374 379.865)"
            fill="#d6d6e3"
          />
          <rect
            width="22.297"
            height="6.768"
            rx="3.384"
            transform="translate(1246.329 380.066)"
            fill="#d6d6e3"
          />
          <rect
            width="22.297"
            height="6.768"
            rx="3.384"
            transform="translate(651.574 427.443)"
            fill="#d6d6e3"
          />
          <rect
            width="22.297"
            height="6.768"
            rx="3.384"
            transform="translate(651.775 475.02)"
            fill="#d6d6e3"
          />
          <rect
            width="22.297"
            height="6.768"
            rx="3.384"
            transform="translate(651.976 522.588)"
            fill="#d6d6e3"
          />
          <g transform="translate(673.671 383.123)" opacity="0.2">
            <rect
              width="6.325"
              height="0.264"
              transform="translate(0 0)"
              fill="#f2f2f2"
            />
            <path
              d="M885.147,405.884H872.718v-.264h12.429Zm-24.869,0H847.848v-.264h12.429Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0H798.1v-.264h12.44Zm-24.869,0H773.23v-.264h12.44Zm-24.88,0H748.361v-.264H760.79Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H648.873v-.264H661.3Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H549.385v-.264h12.429Zm-24.869,0H524.516v-.264h12.429Zm-24.869,0h-12.4v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H449.9v-.264h12.429Zm-24.869,0H425.028v-.264h12.45Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H350.41v-.264h12.429Z"
              transform="translate(-331.645 -405.62)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(565.942 0)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(0 0)"
              fill="#f2f2f2"
            />
            <path
              d="M885.147,405.884H872.718v-.264h12.429Zm-24.869,0H847.848v-.264h12.429Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0H798.1v-.264h12.44Zm-24.869,0H773.23v-.264h12.44Zm-24.88,0H748.361v-.264H760.79Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H648.873v-.264H661.3Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H549.385v-.264h12.429Zm-24.869,0H524.516v-.264h12.429Zm-24.869,0h-12.4v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H449.9v-.264h12.429Zm-24.869,0H425.028v-.264h12.45Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H350.41v-.264h12.429Z"
              transform="translate(-331.645 -405.62)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(565.942 0)"
              fill="#f2f2f2"
            />
          </g>
          <rect
            width="22.297"
            height="6.768"
            rx="3.384"
            transform="translate(651.374 332.424)"
            fill="#d6d6e3"
          />
          <rect
            width="22.297"
            height="6.768"
            rx="3.384"
            transform="translate(1246.329 332.627)"
            fill="#d6d6e3"
          />
          <g transform="translate(673.671 335.684)" opacity="0.2">
            <rect
              width="6.325"
              height="0.264"
              transform="translate(0 0)"
              fill="#f2f2f2"
            />
            <path
              d="M885.147,360.884H872.718v-.264h12.429Zm-24.869,0H847.848v-.264h12.429Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0H798.1v-.264h12.44Zm-24.869,0H773.23v-.264h12.44Zm-24.88,0H748.361v-.264H760.79Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H648.873v-.264H661.3Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H549.385v-.264h12.429Zm-24.869,0H524.516v-.264h12.429Zm-24.869,0h-12.4v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H449.9v-.264h12.429Zm-24.869,0H425.028v-.264h12.45Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H350.41v-.264h12.429Z"
              transform="translate(-331.645 -360.62)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(565.942 0)"
              fill="#f2f2f2"
            />
          </g>
          <rect
            width="22.297"
            height="6.768"
            rx="3.384"
            transform="translate(1246.329 427.443)"
            fill="#d6d6e3"
          />
          <g transform="translate(673.671 430.49)" opacity="0.2">
            <rect
              width="6.325"
              height="0.264"
              transform="translate(0 0.011)"
              fill="#f2f2f2"
            />
            <path
              d="M885.147,450.814H872.718v-.264h12.429Zm-24.869,0H847.848v-.264h12.429Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0H798.1v-.264h12.44Zm-24.869,0H773.23v-.264h12.44Zm-24.88,0H748.361v-.264H760.79Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H648.873v-.264H661.3Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H549.385v-.264h12.429Zm-24.869,0H524.516v-.264h12.429Zm-24.869,0h-12.4v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H449.9v-.264h12.429Zm-24.869,0H425.028v-.264h12.45Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H350.41v-.264h12.429Z"
              transform="translate(-331.645 -450.55)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(565.942 0.011)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(0 0.011)"
              fill="#f2f2f2"
            />
            <path
              d="M885.147,450.814H872.718v-.264h12.429Zm-24.869,0H847.848v-.264h12.429Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0H798.1v-.264h12.44Zm-24.869,0H773.23v-.264h12.44Zm-24.88,0H748.361v-.264H760.79Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H648.873v-.264H661.3Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H549.385v-.264h12.429Zm-24.869,0H524.516v-.264h12.429Zm-24.869,0h-12.4v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H449.9v-.264h12.429Zm-24.869,0H425.028v-.264h12.45Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H350.41v-.264h12.429Z"
              transform="translate(-331.645 -450.55)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(565.942 0.011)"
              fill="#f2f2f2"
            />
          </g>
          <rect
            width="22.297"
            height="6.768"
            rx="3.384"
            transform="translate(1246.329 474.82)"
            fill="#d6d6e3"
          />
          <g transform="translate(673.671 477.867)" opacity="0.2">
            <rect
              width="6.325"
              height="0.264"
              transform="translate(0 0)"
              fill="#f2f2f2"
            />
            <path
              d="M885.147,495.754H872.718v-.264h12.429Zm-24.869,0H847.848v-.264h12.429Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0H798.1v-.264h12.44Zm-24.869,0H773.23v-.264h12.44Zm-24.88,0H748.361v-.264H760.79Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H648.873v-.264H661.3Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H549.385v-.264h12.429Zm-24.869,0H524.516v-.264h12.429Zm-24.869,0h-12.4v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H449.9v-.264h12.429Zm-24.869,0H425.028v-.264h12.45Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H350.41v-.264h12.429Z"
              transform="translate(-331.645 -495.49)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(565.942 0)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(0 0)"
              fill="#f2f2f2"
            />
            <path
              d="M885.147,495.754H872.718v-.264h12.429Zm-24.869,0H847.848v-.264h12.429Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0H798.1v-.264h12.44Zm-24.869,0H773.23v-.264h12.44Zm-24.88,0H748.361v-.264H760.79Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H648.873v-.264H661.3Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H549.385v-.264h12.429Zm-24.869,0H524.516v-.264h12.429Zm-24.869,0h-12.4v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H449.9v-.264h12.429Zm-24.869,0H425.028v-.264h12.45Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H350.41v-.264h12.429Z"
              transform="translate(-331.645 -495.49)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(565.942 0)"
              fill="#f2f2f2"
            />
          </g>
          <rect
            width="22.297"
            height="6.768"
            rx="3.384"
            transform="translate(1246.329 522.186)"
            fill="#d6d6e3"
          />
          <g transform="translate(673.671 525.244)" opacity="0.2">
            <rect
              width="6.325"
              height="0.264"
              transform="translate(0 0)"
              fill="#f2f2f2"
            />
            <path
              d="M885.147,540.694H872.718v-.264h12.429Zm-24.869,0H847.848v-.264h12.429Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0H798.1v-.264h12.44Zm-24.869,0H773.23v-.264h12.44Zm-24.88,0H748.361v-.264H760.79Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H648.873v-.264H661.3Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H549.385v-.264h12.429Zm-24.869,0H524.516v-.264h12.429Zm-24.869,0h-12.4v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H449.9v-.264h12.429Zm-24.869,0H425.028v-.264h12.45Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H350.41v-.264h12.429Z"
              transform="translate(-331.645 -540.43)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(565.942 0)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(0 0)"
              fill="#f2f2f2"
            />
            <path
              d="M885.147,540.694H872.718v-.264h12.429Zm-24.869,0H847.848v-.264h12.429Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0H798.1v-.264h12.44Zm-24.869,0H773.23v-.264h12.44Zm-24.88,0H748.361v-.264H760.79Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H648.873v-.264H661.3Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H549.385v-.264h12.429Zm-24.869,0H524.516v-.264h12.429Zm-24.869,0h-12.4v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H449.9v-.264h12.429Zm-24.869,0H425.028v-.264h12.45Zm-24.869,0h-12.44v-.264h12.44Zm-24.869,0h-12.44v-.264h12.44Zm-24.88,0H350.41v-.264h12.429Z"
              transform="translate(-331.645 -540.43)"
              fill="#f2f2f2"
            />
            <rect
              width="6.325"
              height="0.264"
              transform="translate(565.942 0)"
              fill="#f2f2f2"
            />
          </g>
          <line
            y2="189.962"
            transform="translate(746.36 336.01)"
            fill="none"
            stroke="#f2f2f2"
            strokeMiterlimit="10"
            strokeWidth="0.1"
          />
          <line
            y2="189.962"
            transform="translate(823.319 336.01)"
            fill="none"
            stroke="#f2f2f2"
            strokeMiterlimit="10"
            strokeWidth="0.1"
          />
          <line
            y2="189.962"
            transform="translate(900.278 336.01)"
            fill="none"
            stroke="#f2f2f2"
            strokeMiterlimit="10"
            strokeWidth="0.1"
          />
          <line
            y2="189.962"
            transform="translate(977.237 336.01)"
            fill="none"
            stroke="#f2f2f2"
            strokeMiterlimit="10"
            strokeWidth="0.1"
          />
          <line
            y2="189.962"
            transform="translate(1054.196 336.01)"
            fill="none"
            stroke="#f2f2f2"
            strokeMiterlimit="10"
            strokeWidth="0.1"
          />
          <line
            y2="189.962"
            transform="translate(1131.154 336.01)"
            fill="none"
            stroke="#f2f2f2"
            strokeMiterlimit="10"
            strokeWidth="0.1"
          />
          <line
            y2="189.962"
            transform="translate(1208.113 336.01)"
            fill="none"
            stroke="#f2f2f2"
            strokeMiterlimit="10"
            strokeWidth="0.1"
          />
          <path
            d="M883.237,348.809l-8.8,9.172a2.687,2.687,0,0,0-.443.643l-5.461,11.249a2.488,2.488,0,0,1-2.435,1.4l-1.75-.137a2.488,2.488,0,0,1-2.214-1.792l-1.687-5.84a2.5,2.5,0,0,0-4.765-.116l-2.836,8.307a2.5,2.5,0,0,1-2.372,1.7H839.645a2.509,2.509,0,0,1-2.467-2.108l-3.057-19.134a2.5,2.5,0,0,0-4.7-.738l-15.676,30.942a2.5,2.5,0,0,1-3.669.917l-9.32-6.578a2.519,2.519,0,0,0-3.342.4l-3.532,4.08a2.383,2.383,0,0,0-.274.39l-9.425,16.309a2.478,2.478,0,0,1-2.414,1.233l-5.746-.569a2.519,2.519,0,0,0-1.181.169l-5.145,2.056a2.5,2.5,0,0,1-3.163-1.318l-1.128-2.583a2.509,2.509,0,0,0-2.4-1.5l-5.883.274a2.467,2.467,0,0,0-1.866.98l-1.666,2.172a2.5,2.5,0,0,1-4.343-.7l-2.108-5.956a2.5,2.5,0,0,0-3.859-1.17l-10.015,7.506L722.193,407.4a2.509,2.509,0,0,1-2.72.274l-8.592-4.459a2.52,2.52,0,0,0-1.5-.253L691.979,405.4a2.509,2.509,0,0,0-2.108,1.919l-3.089,13.42a2.5,2.5,0,0,1-4.059,1.339h0a2.509,2.509,0,0,0-3.869.78l-2.372,4.755a2.53,2.53,0,0,1-1.824,1.349l-5.387.9a2.509,2.509,0,0,0-.97.39l-8.487,5.651a2.478,2.478,0,0,1-1.381.422h-3.974a2.5,2.5,0,0,1-2.3-1.508l-1.054-2.52a2.5,2.5,0,0,0-3.352-1.255l-9.214,4.312a2.509,2.509,0,0,1-2.351-.116l-4.217-2.541a2.519,2.519,0,0,0-1.286-.358h-9.309a2.5,2.5,0,0,0-1.381.422l-9.288,6.167a2.5,2.5,0,0,1-2.446.179l-4.217-1.992a2.5,2.5,0,0,0-2.941.622l-2,2.288a2.488,2.488,0,0,1-4.059-.422l-.6-1.054a2.5,2.5,0,0,0-3.458-.928l-7.306,4.333a2.5,2.5,0,0,1-2.488,0l-3.015-1.676a2.478,2.478,0,0,0-2.246-.095l-2.867,1.307a2.52,2.52,0,0,1-3.426-1.518l-1.856-5.524a2.478,2.478,0,0,0-2.383-1.74h-2.7a2.446,2.446,0,0,1-1.212-.316l-10.363-5.682a2.509,2.509,0,0,0-2.7.2l-7.6,5.693a2.478,2.478,0,0,1-1.5.5h-9.562a2.478,2.478,0,0,0-1.381.422l-1.792,1.191a2.5,2.5,0,0,1-3.627-.959l-.432-.854A2.488,2.488,0,0,0,520.3,431.5h-4.8a2.5,2.5,0,0,0-1.971.97l-2.973,3.806a2.5,2.5,0,0,1-4.08-.2l-.843-1.318a2.488,2.488,0,0,0-3.395-.8l-2.467,1.476a2.509,2.509,0,0,1-2.752-.116l-9.941-7.2a3.019,3.019,0,0,0-.569-.316l-7.77-2.983a2.5,2.5,0,0,0-3.163,1.392l-5.408,13.178a2.256,2.256,0,0,0-.158.58l-1.75,11.871a2.509,2.509,0,0,1-.654,1.339l-3.7,3.974a2.52,2.52,0,0,1-3.047.474l-6.42-3.563a2.5,2.5,0,0,0-3.584,1.37l-4.069,11.9a2.394,2.394,0,0,0-.137.812v7.506a2.5,2.5,0,0,1-1.508,2.288l-6.526,2.889a2.5,2.5,0,0,1-2.267-.148l-4.913-2.889a2.5,2.5,0,0,0-1.624-.316l-8.613,1.233a2.488,2.488,0,0,1-2.509-1.223L417.236,475a2.477,2.477,0,0,0-1.413-1.117l-3.911-1.223a2.488,2.488,0,0,0-2.6.706l-5.429,6.03a2.53,2.53,0,0,1-1.655.822l-8.012.675a2.362,2.362,0,0,0-1.054.316l-13.969,8.033a2.509,2.509,0,0,1-2.8-.221l-3.964-3.163a2.53,2.53,0,0,0-1.56-.548H355.848a2.478,2.478,0,0,1-1.95-.938l-3.785-4.723a2.5,2.5,0,0,0-3.806-.105l-4.554,5.06a2.5,2.5,0,0,0-.643,1.666v62.874a2.5,2.5,0,0,0,2.5,2.5H885.2a2.5,2.5,0,0,0,2.5-2.509l-.148-198.543a2.509,2.509,0,0,0-4.312-1.782Z"
            transform="translate(341.522 -25.619)"
            fill="#17376f"
            opacity="0.246"
          />
          <path
            d="M882.751,426.027l-8.16,5.44a3.164,3.164,0,0,0-.748.706l-5.071,6.694a3.163,3.163,0,0,1-2.615,1.223l-1.655-.084a3.1,3.1,0,0,1-2.667-1.813l-1.054-2.245a3.078,3.078,0,0,0-5.535-.179l-2.109,4.038a3.078,3.078,0,0,1-2.73,1.634H839.949a3.068,3.068,0,0,1-2.994-2.34l-2.509-10.047a3.089,3.089,0,0,0-5.419-1.17l-15.076,19.061a3.068,3.068,0,0,1-3.69.9l-9.688-4.375a3.089,3.089,0,0,0-3.163.327l-3.468,2.562a2.866,2.866,0,0,0-.453.422L784.339,456.9a3.089,3.089,0,0,1-2.488,1.054l-5.977-.38a3.334,3.334,0,0,0-.97.084l-5.387,1.381A3.078,3.078,0,0,1,766.2,457.8l-.611-.907a3.089,3.089,0,0,0-2.636-1.339l-6.009.179a2.973,2.973,0,0,0-1.887.717l-1.476,1.234a3.089,3.089,0,0,1-4.691-.875l-1.56-2.825a3.089,3.089,0,0,0-4.038-1.3l-10.11,4.86-11.185,5.777a3.068,3.068,0,0,1-2.383.179l-8.908-2.952a3.162,3.162,0,0,0-1.244-.148L692.21,461.87a3.163,3.163,0,0,0-2.635,2.035l-2.5,6.979a3.089,3.089,0,0,1-4.386,1.666l-.105-.053a3.068,3.068,0,0,0-3.911.8l-1.961,2.509a3.163,3.163,0,0,1-2.108,1.17l-5.4.58a3.164,3.164,0,0,0-.885.221l-8.55,3.658a3.226,3.226,0,0,1-1.212.242h-4.112a3.089,3.089,0,0,1-2.551-1.349l-.59-.865a3.089,3.089,0,0,0-3.437-1.212l-9.583,2.9a3.1,3.1,0,0,1-2-.074l-4.449-1.708a3.036,3.036,0,0,0-1.054-.211h-9.551a2.962,2.962,0,0,0-1.2.253l-9.488,4.027a3.058,3.058,0,0,1-2.109.116l-4.691-1.4a3.1,3.1,0,0,0-2.709.464l-2.056,1.508a3.089,3.089,0,0,1-4.143-.453l-.306-.348a3.089,3.089,0,0,0-3.416-.854l-7.643,2.92a3.078,3.078,0,0,1-2.108,0l-3.353-1.2a3.163,3.163,0,0,0-1.9-.053l-3.163.917a3.089,3.089,0,0,1-3.616-1.581l-1.181-2.372a3.1,3.1,0,0,0-2.762-1.708h-2.741a3.058,3.058,0,0,1-1.054-.169l-10.637-3.732a3.057,3.057,0,0,0-2.362.126l-7.77,3.732a3.162,3.162,0,0,1-1.339.306h-9.815a3.225,3.225,0,0,0-1.212.242l-2,.864a3.1,3.1,0,0,1-3.648-.938h0a3.078,3.078,0,0,0-2.435-1.191h-4.955a3.1,3.1,0,0,0-1.961.7l-2.878,2.361a3.068,3.068,0,0,1-4.143-.211l-.654-.654a3.089,3.089,0,0,0-3.3-.706l-2.867,1.107a3.163,3.163,0,0,1-2.414-.084l-10.089-4.681a2.5,2.5,0,0,0-.559-.19l-7.917-1.95a3.068,3.068,0,0,0-3.331,1.328l-4.976,7.759a3.161,3.161,0,0,0-.411.97l-1.508,6.589a3.163,3.163,0,0,1-1.265,1.855l-3.289,2.256a3.058,3.058,0,0,1-2.773.358l-6.768-2.4a3.089,3.089,0,0,0-3.785,1.518l-3.563,6.663a3.164,3.164,0,0,0-.358,1.455v3a3.1,3.1,0,0,1-2.267,2.973l-5.925,1.645a3.036,3.036,0,0,1-1.908-.084l-5.166-1.95a3.035,3.035,0,0,0-1.37-.19l-8.908.812a3.058,3.058,0,0,1-2.562-.991l-1.054-1.17a2.994,2.994,0,0,0-1.676-.949l-4.059-.822a3.162,3.162,0,0,0-2.4.517l-5.345,3.806a3.162,3.162,0,0,1-1.623.569l-8.191.432a3.228,3.228,0,0,0-.907.19l-14.222,5.271a3.015,3.015,0,0,1-2.467-.148l-4.111-2.108a3.088,3.088,0,0,0-1.4-.337H355.752a3.089,3.089,0,0,1-1.94-.685l-3.7-2.963a3.089,3.089,0,0,0-3.721-.105l-3.964,2.825a3.1,3.1,0,0,0-1.3,2.52v29.634a3.089,3.089,0,0,0,3.089,3.089H884.607a3.089,3.089,0,0,0,3.089-3.089l-.148-115.723a3.089,3.089,0,0,0-4.8-2.615Z"
            transform="translate(341.523 -21.418)"
            fill="#17376f"
            opacity="0.503"
          />
          <ellipse
            cx="7.38"
            cy="7.38"
            rx="7.38"
            ry="7.38"
            transform="translate(1219.077 396.449)"
            fill="#17376f"
          />
          <path
            d="M884.46,494.516l-10.026,3.342a2.619,2.619,0,0,0-.548.263l-5.5,3.637a2.341,2.341,0,0,1-1.349.379l-3.426-.084a2.34,2.34,0,0,1-1.687-.77l-2.108-2.319a2.351,2.351,0,0,0-3.352-.137l-3.553,3.331a2.32,2.32,0,0,1-1.6.643H838.991a2.33,2.33,0,0,1-2.108-1.307l-2.815-5.619a2.351,2.351,0,0,0-3.352-.938l-17.426,11.038a2.372,2.372,0,0,1-1.771.306l-11.934-2.688a2.287,2.287,0,0,0-1.328.084L793.9,505.29a1.486,1.486,0,0,0-.327.148l-9.625,5.334a2.426,2.426,0,0,1-1.212.3l-7.127-.232a2.116,2.116,0,0,0-.369,0l-6.852.875a2.393,2.393,0,0,1-1.687-.432l-1.392-1.054a2.319,2.319,0,0,0-1.423-.453l-7.517.105a2.234,2.234,0,0,0-.875.179l-3.374,1.423a2.361,2.361,0,0,1-2.488-.432l-2.762-2.446a2.341,2.341,0,0,0-2.108-.538l-11.533,2.783-11.86,3.068a2.311,2.311,0,0,1-.97,0l-10.015-1.666a3.737,3.737,0,0,0-.485,0l-18.523.833a2.34,2.34,0,0,0-1.8.98l-2.794,3.848a2.34,2.34,0,0,1-2.53.9l-2.984-.822a2.383,2.383,0,0,0-1.887.3l-2.983,1.908a2.413,2.413,0,0,1-1.139.358l-6.325.348a2.092,2.092,0,0,0-.358,0l-9.13,1.95a2.632,2.632,0,0,1-.5.053h-5.356a2.33,2.33,0,0,1-1.381-.453l-1.391-1.054a2.308,2.308,0,0,0-1.729-.432l-11.4,1.708a2.486,2.486,0,0,1-.791,0l-5.356-1.054a2.113,2.113,0,0,0-.443,0H620.829a2.529,2.529,0,0,0-.485,0l-10.426,2.214a2.267,2.267,0,0,1-.843,0l-6.209-.938a2.413,2.413,0,0,0-1.16.126l-3.985,1.455a2.309,2.309,0,0,1-1.971-.169l-1.887-1.054a2.277,2.277,0,0,0-1.592-.274l-9.488,1.8a2.327,2.327,0,0,1-.854,0l-4.565-.812a2.551,2.551,0,0,0-.749,0l-5.039.727a2.319,2.319,0,0,1-1.992-.654l-1.666-1.592a2.4,2.4,0,0,0-1.666-.685h-4a2.473,2.473,0,0,1-.4,0l-11.66-2.045a2.269,2.269,0,0,0-.959,0l-8.813,2.108a2.358,2.358,0,0,1-.548.063H529.258a2.43,2.43,0,0,0-.485,0l-3.595.77a2.4,2.4,0,0,1-1.8-.211l-.991-.643a2.361,2.361,0,0,0-1.265-.369H514.7a2.329,2.329,0,0,0-.886.179l-4.491,1.834a2.309,2.309,0,0,1-1.94-.074l-2.383-1.2a2.372,2.372,0,0,0-1.5-.211l-4.7.907a2.319,2.319,0,0,1-.97,0l-10.9-2.53h-.242l-9.267-1.149a2.382,2.382,0,0,0-1.729.485l-5.271,4.09a2.3,2.3,0,0,0-.685.865l-1.181,2.625a2.372,2.372,0,0,1-1.37,1.244l-4.048,1.381a2.215,2.215,0,0,1-1.17.095l-9-1.6a2.361,2.361,0,0,0-2.014.6l-3.574,3.342a2.34,2.34,0,0,0-.738,1.718h0a2.341,2.341,0,0,1-2.025,2.319l-6.757.938a2.3,2.3,0,0,1-.759,0l-6.115-1.16a2.366,2.366,0,0,0-.548,0l-10.215.464a2.414,2.414,0,0,1-1.233-.285l-1.792-.981a2.235,2.235,0,0,0-.9-.285l-5.366-.538a2.4,2.4,0,0,0-1.054.127l-6.325,2.245a2.407,2.407,0,0,1-.727.137l-8.993.242a2.185,2.185,0,0,0-.369,0l-15.234,2.815a2.466,2.466,0,0,1-1,0l-5.187-1.328a2.733,2.733,0,0,0-.59-.074H355.1a2.236,2.236,0,0,1-.875-.169l-5.124-2.045a2.33,2.33,0,0,0-1.666,0l-4.765,1.7a2.33,2.33,0,0,0-1.56,2.2v1.054a2.34,2.34,0,0,0,2.34,2.351H885.325a2.34,2.34,0,0,0,2.34-2.351l-.137-44.562a2.351,2.351,0,0,0-3.068-2.33Z"
            transform="translate(341.522 -17.682)"
            fill="#17376f"
          />
          <ellipse
            cx="7.38"
            cy="7.38"
            rx="7.38"
            ry="7.38"
            transform="translate(813.198 445.998)"
            fill="#17376f"
          />
          <ellipse
            cx="7.38"
            cy="7.38"
            rx="7.38"
            ry="7.38"
            transform="translate(1167.42 399.611)"
            fill="#17376f"
          />
          <ellipse
            cx="7.38"
            cy="7.38"
            rx="7.38"
            ry="7.38"
            transform="translate(983.984 449.16)"
            fill="#17376f"
          />
          <ellipse
            cx="7.38"
            cy="7.38"
            rx="7.38"
            ry="7.38"
            transform="translate(1079.919 422.805)"
            fill="#17376f"
          />
          <path
            d="M378.951,516.427a3.518,3.518,0,0,1-1.631-.4l-4.108-2.107a2.6,2.6,0,0,0-1.174-.282H356.752a3.6,3.6,0,0,1-2.254-.8l-3.7-2.961a2.6,2.6,0,0,0-3.119-.088l-3.964,2.825a2.6,2.6,0,0,0-1.087,2.113h-1a3.607,3.607,0,0,1,1.506-2.926l3.965-2.826a3.6,3.6,0,0,1,4.324.122l3.7,2.963a2.6,2.6,0,0,0,1.627.575h15.286a3.606,3.606,0,0,1,1.629.392l4.112,2.109a2.52,2.52,0,0,0,2.061.125l14.225-5.272a3.73,3.73,0,0,1,1.049-.22l8.2-.433a2.657,2.657,0,0,0,1.362-.479l5.342-3.8a3.685,3.685,0,0,1,2.787-.6h.006l4.053.821a3.513,3.513,0,0,1,1.956,1.107l1.053,1.168a2.567,2.567,0,0,0,2.142.828l8.911-.812a3.556,3.556,0,0,1,1.6.221l5.163,1.949a2.554,2.554,0,0,0,1.6.071l5.927-1.645a2.609,2.609,0,0,0,1.9-2.493v-3a3.68,3.68,0,0,1,.415-1.686l0,0,3.562-6.659a3.6,3.6,0,0,1,4.394-1.757l6.769,2.4a2.564,2.564,0,0,0,2.322-.3l3.29-2.257a2.658,2.658,0,0,0,1.061-1.557l1.507-6.587a3.656,3.656,0,0,1,.477-1.127l4.976-7.76a3.563,3.563,0,0,1,3.873-1.543l7.908,1.948a3,3,0,0,1,.663.226h0l10.084,4.678a2.643,2.643,0,0,0,2.029.069l2.862-1.1a3.59,3.59,0,0,1,3.835.82l.652.652a2.568,2.568,0,0,0,3.471.179l2.88-2.363a3.611,3.611,0,0,1,2.274-.809h4.962a3.6,3.6,0,0,1,2.827,1.385,2.6,2.6,0,0,0,3.057.785l2.008-.867a3.707,3.707,0,0,1,1.4-.28h9.817a2.677,2.677,0,0,0,1.124-.257l7.768-3.731a3.578,3.578,0,0,1,2.747-.146l10.634,3.731a2.544,2.544,0,0,0,.88.141h2.749a3.582,3.582,0,0,1,3.209,1.983l1.181,2.374a2.59,2.59,0,0,0,3.03,1.324l3.162-.917a3.647,3.647,0,0,1,2.2.06l.006,0,3.352,1.2a2.583,2.583,0,0,0,1.766,0L591.931,482a3.605,3.605,0,0,1,3.97.992l.305.347a2.576,2.576,0,0,0,3.472.38l2.055-1.507a3.621,3.621,0,0,1,3.148-.54l4.692,1.4a2.562,2.562,0,0,0,1.767-.1l9.49-4.028a3.441,3.441,0,0,1,1.394-.293h9.565a3.526,3.526,0,0,1,1.228.246l4.445,1.706a2.612,2.612,0,0,0,1.68.062l9.582-2.9a3.577,3.577,0,0,1,3.994,1.408l.591.865a2.587,2.587,0,0,0,2.138,1.131h4.111a2.71,2.71,0,0,0,1.019-.2l8.554-3.66a3.665,3.665,0,0,1,1.025-.256l5.394-.579a2.643,2.643,0,0,0,1.771-.985l1.958-2.505a3.568,3.568,0,0,1,4.537-.936l.112.057a2.589,2.589,0,0,0,3.676-1.4l2.5-6.985a3.642,3.642,0,0,1,3.052-2.356h.009l17.247-1.476a3.649,3.649,0,0,1,1.443.171l8.909,2.952a2.583,2.583,0,0,0,2-.149l11.2-5.783,10.11-4.86a3.592,3.592,0,0,1,4.692,1.506l1.56,2.825a2.589,2.589,0,0,0,3.932.734l1.474-1.232a3.479,3.479,0,0,1,2.2-.835l6.007-.179A3.571,3.571,0,0,1,767,456.6l.614.91a2.583,2.583,0,0,0,2.78,1.04l5.4-1.384a3.829,3.829,0,0,1,1.115-.1l5.974.379a2.573,2.573,0,0,0,2.085-.884l.006-.006,9.146-10.126a3.367,3.367,0,0,1,.53-.493l3.47-2.563a3.581,3.581,0,0,1,3.669-.379l9.685,4.374a2.561,2.561,0,0,0,3.091-.749l15.077-19.062a3.589,3.589,0,0,1,6.3,1.359l2.509,10.047a2.561,2.561,0,0,0,2.5,1.962h10.482a2.572,2.572,0,0,0,2.279-1.369l2.107-4.035a3.578,3.578,0,0,1,6.432.2l1.056,2.248a2.59,2.59,0,0,0,2.237,1.521l1.649.084a2.665,2.665,0,0,0,2.2-1.029l5.068-6.69a3.654,3.654,0,0,1,.868-.819l8.162-5.441a3.589,3.589,0,0,1,5.574,2.976l-1,0a2.589,2.589,0,0,0-4.02-2.147l-8.159,5.439a2.65,2.65,0,0,0-.628.593l-5.073,6.7a3.672,3.672,0,0,1-3.028,1.416h-.007l-1.655-.084a3.586,3.586,0,0,1-3.1-2.105l-1.056-2.249a2.578,2.578,0,0,0-4.636-.15l-2.108,4.036a3.57,3.57,0,0,1-3.161,1.9H840.933a3.556,3.556,0,0,1-3.464-2.722l-2.508-10.044a2.589,2.589,0,0,0-4.542-.981l-15.075,19.06a3.557,3.557,0,0,1-4.29,1.041l-9.692-4.377a2.585,2.585,0,0,0-2.651.274l-3.471,2.564a2.361,2.361,0,0,0-.372.347l-.007.008-9.15,10.13a3.567,3.567,0,0,1-2.886,1.219h-.006l-5.978-.379a2.821,2.821,0,0,0-.82.071l-5.381,1.38a3.585,3.585,0,0,1-3.858-1.447l-.613-.909a2.581,2.581,0,0,0-2.207-1.119l-6.015.179a2.478,2.478,0,0,0-1.57.6l-.005,0-1.476,1.234a3.589,3.589,0,0,1-5.45-1.017l-1.56-2.825a2.591,2.591,0,0,0-3.385-1.087l-10.1,4.857-11.177,5.773a3.588,3.588,0,0,1-2.772.209l-8.906-2.951a2.649,2.649,0,0,0-1.046-.124l-17.241,1.475a2.648,2.648,0,0,0-2.212,1.708l-2.5,6.976a3.589,3.589,0,0,1-5.088,1.94l-.116-.059a2.555,2.555,0,0,0-3.274.671l-1.962,2.51a3.642,3.642,0,0,1-2.445,1.359l-5.4.58a2.668,2.668,0,0,0-.748.186l-8.55,3.658a3.709,3.709,0,0,1-1.4.28h-4.114a3.586,3.586,0,0,1-2.964-1.568l-.59-.864a2.58,2.58,0,0,0-2.88-1.016l-9.582,2.9a3.618,3.618,0,0,1-2.327-.086l-4.449-1.708a2.535,2.535,0,0,0-.878-.178h-9.552a2.447,2.447,0,0,0-1,.21l-.007,0-9.488,4.027a3.559,3.559,0,0,1-2.45.134l-4.688-1.4a2.614,2.614,0,0,0-2.272.389l-2.054,1.506a3.589,3.589,0,0,1-4.814-.526l-.306-.348a2.6,2.6,0,0,0-2.863-.716l-7.649,2.922a3.584,3.584,0,0,1-2.451,0l-3.347-1.2a2.65,2.65,0,0,0-1.595-.043l-3.16.916a3.591,3.591,0,0,1-4.2-1.837l-1.182-2.374a2.586,2.586,0,0,0-2.316-1.431h-2.736a3.556,3.556,0,0,1-1.222-.2l-10.639-3.733a2.575,2.575,0,0,0-1.978.1l-7.771,3.733a3.689,3.689,0,0,1-1.553.355h-9.818a2.711,2.711,0,0,0-1.021.2l-2,.862a3.607,3.607,0,0,1-4.239-1.088,2.6,2.6,0,0,0-2.039-1h-4.961a2.607,2.607,0,0,0-1.642.584l-2.877,2.36a3.568,3.568,0,0,1-4.817-.247l-.651-.651a2.591,2.591,0,0,0-2.767-.593l-2.872,1.109a3.639,3.639,0,0,1-2.8-.1l-10.1-4.685a2,2,0,0,0-.447-.152l-.016,0-7.917-1.95a2.565,2.565,0,0,0-2.79,1.111l-4.977,7.76a2.653,2.653,0,0,0-.346.816l-1.508,6.59a3.659,3.659,0,0,1-1.465,2.149l-3.293,2.258a3.564,3.564,0,0,1-3.225.416l-6.766-2.4a2.6,2.6,0,0,0-3.171,1.273l-.005.01-3.561,6.658h0a2.673,2.673,0,0,0-.3,1.225v3a3.614,3.614,0,0,1-2.632,3.454l-5.925,1.645a3.558,3.558,0,0,1-2.22-.1l-5.164-1.95a2.554,2.554,0,0,0-1.148-.16l-8.909.812a3.571,3.571,0,0,1-2.978-1.153l-1.055-1.171a2.509,2.509,0,0,0-1.4-.792h-.006l-4.058-.822a2.678,2.678,0,0,0-2.018.436l-5.342,3.8a3.663,3.663,0,0,1-1.883.661l-8.2.432a2.721,2.721,0,0,0-.761.16l-14.219,5.27A3.5,3.5,0,0,1,378.951,516.427Z"
            transform="translate(341.578 -21.418)"
            fill="#17376f"
          />
          <ellipse
            cx="5.271"
            cy="5.271"
            rx="5.271"
            ry="5.271"
            transform="translate(741.511 564.07)"
            fill="#d6d6e3"
          />
          <ellipse
            cx="5.271"
            cy="5.271"
            rx="5.271"
            ry="5.271"
            transform="translate(818.47 564.07)"
            fill="#d6d6e3"
          />
          <ellipse
            cx="5.271"
            cy="5.271"
            rx="5.271"
            ry="5.271"
            transform="translate(895.429 564.07)"
            fill="#d6d6e3"
          />
          <ellipse
            cx="5.271"
            cy="5.271"
            rx="5.271"
            ry="5.271"
            transform="translate(972.387 564.07)"
            fill="#d6d6e3"
          />
          <ellipse
            cx="5.271"
            cy="5.271"
            rx="5.271"
            ry="5.271"
            transform="translate(1049.346 564.07)"
            fill="#d6d6e3"
          />
          <ellipse
            cx="5.271"
            cy="5.271"
            rx="5.271"
            ry="5.271"
            transform="translate(1126.305 564.07)"
            fill="#d6d6e3"
          />
          <ellipse
            cx="5.271"
            cy="5.271"
            rx="5.271"
            ry="5.271"
            transform="translate(1203.264 564.07)"
            fill="#d6d6e3"
          />
        </g>
      </g>
    </svg>
  );
};

export const IllustrationForgotPassword = (props: IIconProps) => {
  const { className = "", scale = 1, color = "#000", style = {} } = props;

  return (
    <svg
      width={`${scale * 800.314}px`}
      height={`${scale * 644.708}px`}
      viewBox="0 0 800.314 644.708"
      style={style}
      className={className}
      fill={color}
    >
      <g transform="translate(-376.703 -155.001)">
        <g transform="translate(376.703 394.331)">
          <path
            d="M602.879,191.732a41.761,41.761,0,0,0,0,83.522H914.1a41.761,41.761,0,1,0,0-83.522Z"
            transform="translate(-561.118 -191.732)"
            fill="#e5e5e5"
          />
          <path
            d="M605.443,202.747a33.309,33.309,0,1,0,0,66.619H916.662a33.309,33.309,0,0,0,0-66.619Z"
            transform="translate(-563.682 -194.296)"
            fill="#fff"
          />
          <path
            d="M685.91,271.217H623.989a1.492,1.492,0,1,1,0-2.983H685.91a1.492,1.492,0,0,1,0,2.983Z"
            transform="translate(-575.405 -209.539)"
            fill="#17376f"
          />
          <path
            d="M788.292,271.865H726.371a1.491,1.491,0,0,1,0-2.983h61.921a1.491,1.491,0,0,1,0,2.983Z"
            transform="translate(-599.236 -209.69)"
            fill="#17376f"
          />
          <path
            d="M890.674,272.513H828.753a1.492,1.492,0,0,1,0-2.983h61.921a1.491,1.491,0,1,1,0,2.983Z"
            transform="translate(-623.067 -209.84)"
            fill="#17376f"
          />
          <path
            d="M993.055,273.161H931.134a1.491,1.491,0,0,1,0-2.983h61.921a1.492,1.492,0,0,1,0,2.983Z"
            transform="translate(-646.898 -209.991)"
            fill="#17376f"
          />
          <circle
            cx="11.509"
            cy="11.509"
            r="11.509"
            transform="translate(67.9 24.934)"
            fill="#17376f"
          />
          <circle
            cx="11.509"
            cy="11.509"
            r="11.509"
            transform="translate(146.926 24.934)"
            fill="#17376f"
          />
          <circle
            cx="11.509"
            cy="11.509"
            r="11.509"
            transform="translate(225.951 24.934)"
            fill="#17376f"
          />
          <circle
            cx="11.509"
            cy="11.509"
            r="11.509"
            transform="translate(304.976 24.934)"
            fill="#17376f"
          />
        </g>
        <g transform="translate(650.718 262.182)">
          <path
            d="M371.108,645.409a10.02,10.02,0,0,1-3.437-.608l-74.652-27.132a10.075,10.075,0,0,1,1.506-19.357L500.7,557.949a10.1,10.1,0,0,1,5.011.292L563.317,576.7a10.077,10.077,0,0,1-.546,19.351L373.64,645.087a10.05,10.05,0,0,1-2.532.323Z"
            transform="translate(-286.383 -150.45)"
            fill="#090814"
          />
          <path
            d="M492.22,518.082l108.275,13.012-19.74,38.069-95.461-13.856c-7.86,5.575-18.784,8.056-30.142,5.944-19.871-3.7-33.5-20.025-30.439-36.474S446.364,498,466.235,501.7C477.592,503.807,486.891,510.054,492.22,518.082Z"
            transform="translate(-256.506 -118.027)"
            fill="#ed9da0"
          />
          <path
            d="M657.371,105.763a86.173,86.173,0,1,0-86.654,108.605l44.807,101.938,63.516-90.48s-23.808-17.772-40.181-40.642a86.079,86.079,0,0,0,18.512-79.421Z"
            transform="translate(-271.314 -11.219)"
            fill="#ed9da0"
          />
          <path
            d="M769.908,342.528a76.523,76.523,0,0,0-70.29-47.753c-39.017-.376-88.681,9.827-90.728,63.75-3.39,89.283,0,53.346,0,53.346s-26.935,67.068,0,99.417S659.311,607.4,659.311,607.4H822.986s-28.256-74.676-23.4-125.623c3.294-34.583-12.416-96.553-29.677-139.245Z"
            transform="translate(-296.688 -70.035)"
            fill="#d6d6e3"
          />
          <path
            d="M830.162,261.161c-4.484,8.084-17.433,7.626-23.823.945s-7.457-16.867-6.454-26.056,3.71-18.226,3.524-27.467c-.356-17.636,22.646,11.185,10.831-1.912s-25.325-25.128-33.4-40.811l-.975-1c3.449-11.392-4.916-23.029-14.332-30.306S744.828,121.719,738.4,111.7c-5.47-8.521-6.575-19-8.969-28.843-9.275-38.121-41.338-69.742-79.583-78.488s-80.866,5.8-105.787,36.1l.6-1.256a45.1,45.1,0,0,0-34,32.428c-1.169,4.639-1.558,9.627,0,14.152s5.348,8.476,10.074,9.225c5.068.8,10.139-2.178,13.262-6.251s4.68-9.1,6.179-14.005a60.626,60.626,0,0,0,44.177,42.3,15.805,15.805,0,0,0,22.527,16.275l1.2-1.144,17.7.8A59.313,59.313,0,0,0,640.95,217.6c10.688,7.046,23.311,10.434,35.714,13.6s16.066,25.373,32.379,44.66c-.864,21.916,15.4,43.3,36.756,48.311l-5.862,19.676c11.877-4.224,24.88-.377,37.42.9s27.745-1.765,32.564-13.412c5.124-12.385-4.659-25.516-13.76-35.355,18.528,1.848,36.29-16.342,34.006-34.819Z"
            transform="translate(-310.117 -1.856)"
            fill="#090814"
          />
          <path
            d="M442.587,595.936l105.437,27.851-24.812,34.974-92.63-26.92c-8.555,4.435-19.718,5.384-30.674,1.721-19.17-6.409-30.41-24.466-25.106-40.331s25.145-23.527,44.318-17.118c10.956,3.663,19.3,11.136,23.47,19.824Z"
            transform="translate(-244.682 -134.996)"
            fill="#ed9da0"
          />
          <path
            d="M687.82,439.676s-4.6,202.27-70.563,195.525-87.792-15.237-87.792-15.237-13.344-50.944,9.7-52.16,53.125-6.887,53.125-6.887v-146.7"
            transform="translate(-280.094 -97.839)"
            fill="#d6d6e3"
          />
        </g>
        <path
          d="M287.66,221.286c-4.3,1.8-8.8-.172-10.68-4.684-1.913-4.58-.126-9.23,4.247-11.056s8.786.148,10.729,4.8C293.871,214.933,292.1,219.43,287.66,221.286Zm-8.246-24.756-3.423,1.429a3.692,3.692,0,0,1-4.69-1.72l-.169-.331c-3.683-6.642-4.1-14.714-1.247-23.98,2.647-8.312,3.747-14.158,1.536-19.454-2.557-6.123-8.016-8.041-14.979-5.263-2.7,1.128-3.56,1.11-5.685,3.218a4.879,4.879,0,0,1-3.532,1.435,4.716,4.716,0,0,1-3.375-1.48,4.817,4.817,0,0,1-.033-6.573,37.414,37.414,0,0,1,12.652-8.687c14.959-6.246,22.489,2.976,25.935,11.228,3.371,8.072,1.475,15.562-1.572,25.261-2.553,8.06-2.4,14.032.5,19.97a3.676,3.676,0,0,1-1.915,4.946Z"
          transform="translate(579.249 21.932)"
          fill="#17376f"
        />
      </g>
    </svg>
  );
};

export const IllustrationResetPassword = (props: IIconProps) => {
  const { className = "", scale = 1, color = "#000", style = {} } = props;

  return (
    <svg
      width={`${scale * 799.031}px`}
      height={`${scale * 618.112}px`}
      viewBox="0 0 799.031 618.112"
      style={style}
      className={className}
      fill={color}
    >
      <g transform="translate(-560 -231.001)">
        <path
          d="M15.18,488.763c0,.872.478,1.573,1.073,1.573h535.1c.6,0,1.073-.7,1.073-1.573s-.478-1.573-1.073-1.573H16.253C15.658,487.191,15.18,487.891,15.18,488.763Z"
          transform="translate(674.711 358.776)"
          fill="#ccc"
        />
        <rect
          width="19.105"
          height="3.371"
          transform="translate(865.162 842.354)"
          fill="#b6b3c5"
        />
        <rect
          width="19.105"
          height="3.371"
          transform="translate(1034.295 842.918)"
          fill="#b6b3c5"
        />
        <path
          d="M352.955,370.945a27.529,27.529,0,0,1-54.321,0H229.146V521.536h193.3V370.945Z"
          transform="translate(633.721 321.378)"
          fill="#d6d6e3"
        />
        <rect
          width="193.296"
          height="5.242"
          transform="translate(863.43 830.984)"
          fill="#090814"
        />
        <path
          d="M788.255,487.17H10.776A10.788,10.788,0,0,1,0,476.394V32.688A10.788,10.788,0,0,1,10.776,21.911H788.255a10.789,10.789,0,0,1,10.776,10.776V476.394a10.789,10.789,0,0,1-10.776,10.776Z"
          transform="translate(560 209.09)"
          fill="#090814"
        />
        <rect
          width="760.822"
          height="429.297"
          transform="translate(577.104 246.057)"
          fill="#fff"
        />
        <rect
          width="257"
          height="32"
          rx="16"
          transform="translate(832 486)"
          fill="#17376f"
        />
        <g transform="translate(14 -27)">
          <rect
            width="257"
            height="32"
            rx="16"
            transform="translate(818 465)"
            fill="#e6e6e6"
          />
          <circle
            cx="6"
            cy="6"
            r="6"
            transform="translate(830 475)"
            fill="#090814"
          />
          <circle
            cx="6"
            cy="6"
            r="6"
            transform="translate(850 475)"
            fill="#090814"
          />
          <circle
            cx="6"
            cy="6"
            r="6"
            transform="translate(870 475)"
            fill="#090814"
          />
          <circle
            cx="6"
            cy="6"
            r="6"
            transform="translate(890 475)"
            fill="#090814"
          />
          <circle
            cx="6"
            cy="6"
            r="6"
            transform="translate(910 475)"
            fill="#090814"
          />
          <circle
            cx="6"
            cy="6"
            r="6"
            transform="translate(930 475)"
            fill="#090814"
          />
          <circle
            cx="6"
            cy="6"
            r="6"
            transform="translate(950 475)"
            fill="#090814"
          />
          <circle
            cx="6"
            cy="6"
            r="6"
            transform="translate(970 475)"
            fill="#090814"
          />
          <circle
            cx="6"
            cy="6"
            r="6"
            transform="translate(990 475)"
            fill="#090814"
          />
        </g>
        <circle
          cx="24"
          cy="24"
          r="24"
          transform="translate(937 324)"
          fill="#e6e6e6"
        />
        <g transform="translate(14 2.113)">
          <g transform="translate(0 50.88)">
            <rect
              width="48"
              height="8"
              transform="translate(977 364)"
              fill="#e6e6e6"
            />
            <path
              d="M0,0H44a4,4,0,0,1,4,4V4a4,4,0,0,1-4,4H0A0,0,0,0,1,0,8V0A0,0,0,0,1,0,0Z"
              transform="translate(1027 364)"
              fill="#17376f"
            />
            <path
              d="M4,0H48a0,0,0,0,1,0,0V8a0,0,0,0,1,0,0H4A4,4,0,0,1,0,4V4A4,4,0,0,1,4,0Z"
              transform="translate(927 364)"
              fill="#e6e6e6"
            />
          </g>
          <g transform="translate(-84 -112)">
            <ellipse
              cx="8.88"
              cy="8.88"
              rx="8.88"
              ry="8.88"
              transform="translate(902 522)"
              fill="#17376f"
            />
            <path
              d="M296.891,358.937a.987.987,0,0,1-.79-.4l-2.423-3.23a.988.988,0,1,1,1.58-1.185l1.585,2.113,4.071-6.106a.988.988,0,0,1,1.644,1.1l-4.845,7.268a.988.988,0,0,1-.794.44Z"
              transform="translate(612.52 176.307)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const IllustrationAcceptInvite = (props: IIconProps) => {
  const { className = "", scale = 1, color = "#000", style = {} } = props;

  return (
    <svg
      width={`${scale * 883.96828}px`}
      height={`${scale * 607.46406}px`}
      viewBox="0 0 883.96828 607.46406"
      className={className}
      fill={color}
      style={style}
    >
      <path
        d="M930.734,274.34051h-.12466l-71.4901,30.52657-97.81319,41.767a3.15484,3.15484,0,0,1-2.41645.01245L657.97519,304.77988l-73.2464-30.38956-.1119-.04981h-.12467a4.364,4.364,0,0,0-4.35916,4.35916V468.01173a4.364,4.364,0,0,0,4.35916,4.35916H930.734a4.364,4.364,0,0,0,4.35916-4.35916V278.69967A4.364,4.364,0,0,0,930.734,274.34051Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#fff"
      />
      <path
        d="M931.04481,275.586a.62087.62087,0,0,1-.35546-.1116L758.46588,155.53305a3.12331,3.12331,0,0,0-3.56736.00608L583.91566,275.47318a.62286.62286,0,0,1-.71532-1.01986l170.983-119.934a4.373,4.373,0,0,1,4.99436-.00821l172.22344,119.941a.62286.62286,0,0,1-.35638,1.13388Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#3f3d56"
      />
      <polygon
        points="435.67 133.57 598.834 12.645 763.237 142.174 607.241 234.65 522.549 215.346 435.67 133.57"
        fill="#e6e6e6"
      />
      <path
        d="M687.71423,438.03708h-80.6073a3.76592,3.76592,0,0,1-.01113-7.53184h80.61843a3.76592,3.76592,0,0,1,.01113,7.53184Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#17376f"
      />
      <path
        d="M636.027,421.84591h-28.9201a3.76592,3.76592,0,0,1-.01113-7.53183H636.027a3.76592,3.76592,0,1,1,.01114,7.53183Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#17376f"
      />
      <path
        d="M759.145,347.19121a4.7102,4.7102,0,0,1-1.78672-.35L656.72972,305.08743V174.39112a4.36425,4.36425,0,0,1,4.35915-4.35916H854.13736a4.36426,4.36426,0,0,1,4.35916,4.35916V305.17865l-.18913.08089-97.32152,41.56129A4.74288,4.74288,0,0,1,759.145,347.19121Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#fff"
      />
      <path
        d="M759.145,347.50227a5.0265,5.0265,0,0,1-1.90531-.37279L656.41835,305.2954V174.39109a4.67581,4.67581,0,0,1,4.67052-4.67052H854.13736a4.67582,4.67582,0,0,1,4.67053,4.67052V305.38421L761.10811,347.107A5.05005,5.05005,0,0,1,759.145,347.50227ZM657.66378,304.46348,757.71464,345.978a3.81,3.81,0,0,0,2.90695-.01733L857.56241,304.562V174.39109a3.42912,3.42912,0,0,0-3.42505-3.425H661.08887a3.42912,3.42912,0,0,0-3.42505,3.425Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#3f3d56"
      />
      <path
        d="M929.79979,274.34051h-.12466L858.185,304.86708l-97.81319,41.767a3.15484,3.15484,0,0,1-2.41645.01245L657.041,304.77988l-73.2464-30.38956-.1119-.04981H583.558a4.364,4.364,0,0,0-4.35916,4.35916V468.01173a4.364,4.364,0,0,0,4.35916,4.35916H929.79979a4.364,4.364,0,0,0,4.35916-4.35916V278.69967A4.364,4.364,0,0,0,929.79979,274.34051Zm3.11369,193.67122a3.11492,3.11492,0,0,1-3.11369,3.11369H583.558a3.11494,3.11494,0,0,1-3.11369-3.11369V278.69967a3.12057,3.12057,0,0,1,2.99541-3.11368L657.041,306.125l100.4352,41.67357a4.43441,4.43441,0,0,0,3.38765-.01868L858.185,306.21844,929.92446,275.586a3.12378,3.12378,0,0,1,2.989,3.11368Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#3f3d56"
      />
      <path
        d="M743.47888,218.88666H674.9778a4.9819,4.9819,0,0,1,0-9.96379h68.50108a4.9819,4.9819,0,0,1,0,9.96379Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#17376f"
      />
      <path
        d="M707.98287,197.7136H674.9778a4.98189,4.98189,0,0,1,0-9.96379h33.00507a4.98189,4.98189,0,0,1,0,9.96379Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#17376f"
      />
      <path
        d="M808.84666,268.70562H704.22683a4.9819,4.9819,0,0,1,0-9.96379H808.84666a4.9819,4.9819,0,0,1,0,9.96379Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#ccc"
      />
      <path
        d="M808.84666,291.7469H704.22683a4.9819,4.9819,0,0,1,0-9.9638H808.84666a4.9819,4.9819,0,0,1,0,9.9638Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#ccc"
      />
      <circle cx="769.85304" cy="129.87784" r="47.37136" fill="#17376f" />
      <polygon
        points="765.339 149.875 751.161 131.644 759.406 125.231 766.119 133.863 788.798 109.922 796.382 117.107 765.339 149.875"
        fill="#fff"
      />
      <path
        d="M397.78109,556.12072a10.05581,10.05581,0,0,1,4.214-14.83234l-3.08079-35.60179,16.326,8.84847.42262,32.45151a10.11027,10.11027,0,0,1-17.8818,9.13415Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#9f616a"
      />
      <path
        d="M400.87455,533.59824l-.13257-.33593-18.01172-45.50293-2.85791-86.25293.48-.03418a26.46617,26.46617,0,0,1,28.32056,25.11328l2.6416,46.374,7.48852,59.64258Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#e5e5e5"
      />
      <polygon
        points="127.8 577.505 138.154 584.07 168.401 547.255 153.119 537.567 127.8 577.505"
        fill="#9f616a"
      />
      <path
        d="M285.31764,718.7182l20.39154,12.92748.00083.00052a15.3873,15.3873,0,0,1,4.756,21.23348l-.26773.42227-33.38677-21.16611Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#2f2e41"
      />
      <polygon
        points="225.692 595.15 237.952 595.149 243.784 547.861 225.69 547.862 225.692 595.15"
        fill="#9f616a"
      />
      <path
        d="M380.58082,737.41524l24.144-.001h.001a15.38731,15.38731,0,0,1,15.38648,15.38623v.5l-39.53077.00146Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#2f2e41"
      />
      <path
        d="M349.01908,543.28431,377.8814,716.88646s-5.67783,14.19459,2.83892,16.0872,27.44285-1.89261,27.44285-1.89261,5.67784-14.19459-2.83891-16.0872l-16.0872-181.38868Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#2f2e41"
      />
      <path
        d="M366.05258,546.38029l-19.99536,81.17409-50.97755,74.02s-18.92611,1.89262-8.51675,12.302S301.70381,725.232,301.70381,725.232s16.08719-1.89261,15.14088-9.463l62.67343-73.77085,29.11821-98.45675Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#2f2e41"
      />
      <path
        d="M348.60331,553.52891l-4.82886-27.55762c-7.272-7.60059,6.46826-26.3916,8.00024-28.43262l-.89892-11.68554a3.50739,3.50739,0,0,1-1.99268-1.085c-4.511-4.60058-4.208-22.751-4.19287-23.52148L339.712,409.46152l12.38574-7.22558,31.322-1.00977L398.7161,414.483l14.73267,135.35156-.52539.0293Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#e5e5e5"
      />
      <path
        d="M359.44328,563.19434a10.05575,10.05575,0,0,1-2.443-15.22456l-17.82547-30.97147,18.53545,1.12735,14.08568,29.23819a10.11028,10.11028,0,0,1-12.35262,15.83049Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#9f616a"
      />
      <path
        d="M343.65751,534.233,328.281,498.58945l-2.56982-72.81152a13.09764,13.09764,0,0,1,6.60693-11.8623l17.73877-10.83985,3.82715,76.544L365.3306,525.3668Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#e5e5e5"
      />
      <circle cx="213.23836" cy="226.04429" r="22.00839" fill="#9f616a" />
      <path
        d="M379.212,339.81577c-22.1648-6.39172-28.4563,11.97907-28.4563,11.97907-10.68384,7.08807-3.99487,15.97473-3.99487,15.97473-2.6958.59881,2.69433,16.37457,4.4917,15.97534.959-.21307,3.425,2.73059,5.5166,5.52228a11.0696,11.0696,0,0,1,2.13672.20538l-4.05811-15.01288s13.67871-2.09564,17.87256-8.68506c4.01245-6.30419,17.22119-8.29455,20.98022-4.08361a9.50485,9.50485,0,0,1,1.34058-3.40387,6.80081,6.80081,0,0,1,1.971-1.97608C393.68851,342.18711,379.212,339.81577,379.212,339.81577Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#2f2e41"
      />
      <polyline
        points="196.224 305.464 194.996 349.275 210.238 381.401 196.224 304.299"
        opacity="0.2"
      />
      <path
        d="M540.01586,753.732h-381a1,1,0,1,1,0-2h381a1,1,0,0,1,0,2Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#3f3d56"
      />
      <path
        d="M487.35223,193.54645a1.99891,1.99891,0,0,0-2.99778,1.99087l1.54384,11.32333a1.29955,1.29955,0,0,1-.03357.49905,1.22138,1.22138,0,0,1-.23734.43608l-8.64673,10.24363a1.95391,1.95391,0,0,0-.12721,2.41351l.00908.01314a1.95123,1.95123,0,0,0,2.28266.752l6.24446-2.1195a1.20226,1.20226,0,0,1,1.20761.27169,1.16219,1.16219,0,0,1,.37242.85434l.24409,22.24892a1.984,1.984,0,0,0,.87415,1.62894,2.004,2.004,0,0,0,1.83248.2134l46.6071-17.82452a1.99756,1.99756,0,0,0,.30651-3.58642l-.63455-.37689-48.84721-28.98158Zm-2.20874,1.88208a1.20067,1.20067,0,0,1,1.8019-1.19268L535.777,223.20879l.65006.38537a1.20112,1.20112,0,0,1-.18261,2.151l-46.60706,17.82454a1.19819,1.19819,0,0,1-1.62406-1.10553l-.244-22.24873a1.91512,1.91512,0,0,0-.1118-.646l47.45031,5.45193a.79968.79968,0,0,0,.47957-1.49692.69588.69588,0,0,0-.125-.0544L486.7016,207.1936a1.97024,1.97024,0,0,0-.01428-.44177l-1.54385-11.32329Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#f1f1f1"
      />
      <path
        d="M487.35223,193.54645a1.99891,1.99891,0,0,0-2.99778,1.99087l1.54384,11.32333a1.29955,1.29955,0,0,1-.03357.49905,1.22138,1.22138,0,0,1-.23734.43608l-8.64673,10.24363a1.95391,1.95391,0,0,0-.12721,2.41351l.00908.01314a1.95123,1.95123,0,0,0,2.28266.752l6.24446-2.1195a1.20226,1.20226,0,0,1,1.20761.27169,1.16219,1.16219,0,0,1,.37242.85434l.24409,22.24892a1.984,1.984,0,0,0,.87415,1.62894,2.004,2.004,0,0,0,1.83248.2134l46.6071-17.82452a1.99756,1.99756,0,0,0,.30651-3.58642l-.63455-.37689-48.84721-28.98158Zm-2.20874,1.88208a1.20067,1.20067,0,0,1,1.8019-1.19268L535.777,223.20879l.65006.38537a1.20112,1.20112,0,0,1-.18261,2.151l-46.60706,17.82453a1.19819,1.19819,0,0,1-1.62405-1.10553l-.24405-22.24875a1.91516,1.91516,0,0,0-.1118-.646,1.94312,1.94312,0,0,0-.5119-.78227c-.03153-.03154-.06634-.06083-.10123-.09025l-.00222-.00321a1.99249,1.99249,0,0,0-1.90795-.35062l-6.24773,2.12177a1.16242,1.16242,0,0,1-1.36924-.45629l-.00455-.00658a1.15986,1.15986,0,0,1,.07714-1.44692l8.64685-10.24347a1.88917,1.88917,0,0,0,.23875-.3498l.0033-.00226a1.91585,1.91585,0,0,0,.15205-.37685,1.857,1.857,0,0,0,.07088-.389,1.97017,1.97017,0,0,0-.01428-.44176l-1.54386-11.32332Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#e5e5e5"
      />
      <path
        d="M486.70158,207.19358,535.46233,223.47a.69687.69687,0,0,1,.125.05439.79969.79969,0,0,1-.47957,1.49693l-47.45032-5.452-.83795-.09542.09278-.79248.1298.01218.00222.0032,48.154,5.5288-48.71965-16.26619-.0033.00226-.21056-.07271.25288-.75767Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#e5e5e5"
      />
      <path
        d="M1031.1283,146.54645,982.28109,175.528l-.63455.37689a1.99756,1.99756,0,0,0,.30651,3.58642l46.6071,17.82452a2.004,2.004,0,0,0,1.83248-.2134,1.984,1.984,0,0,0,.87415-1.62894l.24409-22.24892a1.16219,1.16219,0,0,1,.37242-.85434,1.20226,1.20226,0,0,1,1.20761-.27169l6.24446,2.1195a1.95123,1.95123,0,0,0,2.28266-.752l.00908-.01314a1.95391,1.95391,0,0,0-.12721-2.41351l-8.64673-10.24363a1.22138,1.22138,0,0,1-.23734-.43608,1.29956,1.29956,0,0,1-.03358-.49905l1.54385-11.32333a1.99891,1.99891,0,0,0-2.99778-1.99087Zm2.20877,1.88209-1.54385,11.32329a1.97024,1.97024,0,0,0-.01428.44177L983.01818,176.47a.69588.69588,0,0,0-.125.0544.79968.79968,0,0,0,.47957,1.49692l47.45031-5.45193a1.91512,1.91512,0,0,0-.1118.646l-.244,22.24873a1.19819,1.19819,0,0,1-1.62406,1.10553l-46.60706-17.82454a1.20112,1.20112,0,0,1-.18261-2.151l.65006-.38537,48.83158-28.97294a1.20067,1.20067,0,0,1,1.8019,1.19268Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#f1f1f1"
      />
      <path
        d="M1031.1283,146.54645,982.28109,175.528l-.63455.37689a1.99756,1.99756,0,0,0,.30651,3.58642l46.6071,17.82452a2.004,2.004,0,0,0,1.83248-.2134,1.984,1.984,0,0,0,.87415-1.62894l.24409-22.24892a1.16219,1.16219,0,0,1,.37242-.85434,1.20226,1.20226,0,0,1,1.20761-.27169l6.24446,2.1195a1.95123,1.95123,0,0,0,2.28266-.752l.00908-.01314a1.95391,1.95391,0,0,0-.12721-2.41351l-8.64673-10.24363a1.22138,1.22138,0,0,1-.23734-.43608,1.29956,1.29956,0,0,1-.03358-.49905l1.54385-11.32333a1.99891,1.99891,0,0,0-2.99778-1.99087Zm2.20877,1.88209-1.54386,11.32332a1.97017,1.97017,0,0,0-.01428.44176,1.857,1.857,0,0,0,.07088.389,1.91585,1.91585,0,0,0,.15205.37685l.0033.00226a1.88917,1.88917,0,0,0,.23875.3498l8.64685,10.24347a1.15986,1.15986,0,0,1,.07714,1.44692l-.00455.00658a1.16242,1.16242,0,0,1-1.36924.45629l-6.24773-2.12177a1.99249,1.99249,0,0,0-1.908.35062l-.00222.00321c-.03489.02942-.0697.05871-.10123.09025a1.94312,1.94312,0,0,0-.5119.78227,1.91516,1.91516,0,0,0-.1118.646l-.24405,22.24875a1.19819,1.19819,0,0,1-1.624,1.10553l-46.60706-17.82453a1.20112,1.20112,0,0,1-.18261-2.151l.65006-.38537,48.83158-28.97294a1.20067,1.20067,0,0,1,1.8019,1.19268Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#e5e5e5"
      />
      <path
        d="M1031.96287,160.13132l.25288.75767-.21056.07271-.0033-.00226-48.71965,16.26619,48.154-5.5288.00222-.0032.1298-.01218.09278.79248-.83795.09542-47.45032,5.452a.79969.79969,0,0,1-.47957-1.49693.69687.69687,0,0,1,.125-.05439l48.76074-16.2764Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#e5e5e5"
      />
      <path
        d="M613.1421,551.48955a1.99891,1.99891,0,0,0,.08063,3.59774l10.39574,4.74657a1.29963,1.29963,0,0,1,.40386.29508,1.22139,1.22139,0,0,1,.24174.43366l4.03707,12.7828a1.95394,1.95394,0,0,0,1.972,1.39736l.016-.00067a1.95122,1.95122,0,0,0,1.85552-1.52744l1.54574-6.41064a1.20226,1.20226,0,0,1,.875-.87549,1.16217,1.16217,0,0,1,.92113.1418l18.93561,11.684a1.98394,1.98394,0,0,0,1.844.1317,2.004,2.004,0,0,0,1.15968-1.43479l9.84234-48.91895a1.99757,1.99757,0,0,0-2.86749-2.17574l-.65768.33491L613.1421,551.48954Zm.41036,2.87269a1.20067,1.20067,0,0,1-.0451-2.16039l50.58517-25.78946.67313-.34349a1.20111,1.20111,0,0,1,1.72043,1.30387L656.6438,576.2917a1.19819,1.19819,0,0,1-1.80235.78186l-18.93542-11.684a1.91519,1.91519,0,0,0-.60576-.25074l29.96662-37.19216a.79968.79968,0,0,0-1.00893-1.20533.6958.6958,0,0,0-.11278.07656l-39.816,32.51493a1.96963,1.96963,0,0,0-.381-.224l-10.39571-4.74655Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#f1f1f1"
      />
      <path
        d="M613.1421,551.48955a1.99891,1.99891,0,0,0,.08063,3.59774l10.39574,4.74657a1.29963,1.29963,0,0,1,.40386.29508,1.22139,1.22139,0,0,1,.24174.43366l4.03707,12.7828a1.95394,1.95394,0,0,0,1.972,1.39736l.016-.00067a1.95122,1.95122,0,0,0,1.85552-1.52744l1.54574-6.41064a1.20226,1.20226,0,0,1,.875-.87549,1.16217,1.16217,0,0,1,.92113.1418l18.93561,11.684a1.98394,1.98394,0,0,0,1.844.1317,2.004,2.004,0,0,0,1.15968-1.43479l9.84234-48.91895a1.99757,1.99757,0,0,0-2.86749-2.17574l-.65768.33491L613.1421,551.48954Zm.41036,2.87269a1.20067,1.20067,0,0,1-.0451-2.16039l50.58517-25.78946.67313-.34349a1.20111,1.20111,0,0,1,1.72043,1.30387l-9.8423,48.91892a1.19819,1.19819,0,0,1-1.80235.78186l-18.93544-11.684a1.91519,1.91519,0,0,0-.60576-.25074,1.94318,1.94318,0,0,0-.93476.01459c-.04351.0098-.08687.02358-.13039.03734l-.00389.00016a1.99248,1.99248,0,0,0-1.316,1.42525l-1.54558,6.41461a1.16244,1.16244,0,0,1-1.11741.91346l-.008.00032a1.15986,1.15986,0,0,1-1.18174-.83847l-4.03687-12.78281a1.89,1.89,0,0,0-.16806-.38874l-.00015-.004a1.91524,1.91524,0,0,0-.23726-.32991,1.85747,1.85747,0,0,0-.29092-.26781,1.97042,1.97042,0,0,0-.381-.224l-10.39573-4.74655Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#e5e5e5"
      />
      <path
        d="M624.32916,559.33283l39.816-32.51492a.6965.6965,0,0,1,.11278-.07657.79968.79968,0,0,1,1.00893,1.20533l-29.96665,37.19216-.52846.65726-.62023-.50194.07965-.1032.0039-.00016,30.40767-37.74588-39.78538,32.48565.00015.004-.174.13911-.50525-.61865Z"
        transform="translate(-158.01586 -146.26797)"
        fill="#e5e5e5"
      />
    </svg>
  );
};

export const IllustrationsWarning = (props: IIconProps) => {
  const { className = "", scale = 1, color = "#000", style = {} } = props;

  return (
    <svg
      width={`${scale * 813.04}px`}
      height={`${scale * 683.381}px`}
      viewBox="0 0 813.04 683.381"
      className={className}
      fill={color}
      style={style}
    >
      <g transform="translate(-553.48 -178.918)">
        <path
          d="M174.447,75.484a66.379,66.379,0,1,1,86.266,63.344l-9.9,7.974,17.767,62.185-20.7,14.646-65.417-54.514s14.132-18,21.711-38.3a66.307,66.307,0,0,1-29.728-55.338Z"
          transform="translate(553.479 250.932)"
          fill="#ed9da0"
        />
        <path
          d="M470.989,245.556,423.431,410.821l-48.1-33.379,56.676-144.191c-4.943-9.154-6.171-21.185-2.417-33.078,6.569-20.809,25.855-33.271,43.076-27.835s25.857,26.712,19.288,47.521c-3.754,11.893-11.668,21.038-20.97,25.7Z"
          transform="translate(553.479 250.932)"
          fill="#ed9da0"
        />
        <rect
          width="171.552"
          height="199.807"
          transform="translate(694.197 561.744)"
          fill="#ed9da0"
        />
        <path
          d="M130.186,435.608,91.274,553.849l-2.318,56.536H376.665L321.177,435.608Z"
          transform="translate(553.479 250.932)"
          fill="#090814"
        />
        <path
          d="M431.948,611.367H32.511a2.539,2.539,0,0,1,0-5.023H431.948a2.533,2.533,0,0,1,0,5.023Z"
          transform="translate(553.479 250.932)"
          fill="#ccc"
        />
        <path
          d="M198.3,151.484l-40.781,93.13,4.035,160.059H299.389l4.327-169.834-51.172-78.874Z"
          transform="translate(553.479 250.932)"
          fill="#17376f"
        />
        <path
          d="M116.371,188.543s-11.939,342.471-44,398.987c0,0,44.3,7.72,55.57-8.247s54.727-122.271,55.2-145.813,14.086-282.1,14.086-282.1l-80.858,37.173Z"
          transform="translate(553.479 250.932)"
          fill="#e6e6e6"
        />
        <path
          d="M248.944,165.377l3.6-9.411,91.407,36.3S339.686,534.514,376.69,569.1c0,0-61.82-2.949-63.873-4.365s-46.934-178.392-46.934-178.392,21.395-81.986,23.046-116.993-39.986-103.97-39.986-103.97Z"
          transform="translate(553.479 250.932)"
          fill="#e6e6e6"
        />
        <path
          d="M320.758,198.956l23.193-6.691,53.329,108,22.855-59.155L476.6,257.247s-25.666,166.562-64.469,157.6-91.375-100.428-91.375-100.428V198.956Z"
          transform="translate(553.479 250.932)"
          fill="#e6e6e6"
        />
        <path
          d="M92.13,528.775,14.3,415.627l35.781-31.48L123.22,507.293c9.486,1.582,18.967,7.508,25.522,16.993,11.468,16.6,9.631,37.744-4.1,47.235S110.468,575.253,99,558.657c-6.554-9.485-8.744-20.449-6.87-29.882Z"
          transform="translate(553.479 250.932)"
          fill="#ed9da0"
        />
        <path
          d="M130.186,198.091l-13.815-9.549L3.361,402s-9.173,12.872,2.792,33.611S79.545,519.86,79.545,519.86l48.4-27.337-49.3-91.87,46.466-80.374,5.071-122.187Z"
          transform="translate(553.479 250.932)"
          fill="#e6e6e6"
        />
        <path
          d="M361.431,19.483c14.844,5.216,23.337,8.2,31.118,15.7,13.141,12.661,15.311,29.58,17.325,45.3,1.577,12.3,3.616,28.2-3.6,46.368-2.458,6.2-11.737,38.016-34.555,41.506-4.481.686-15,.865-11.97-1.374,28.067-20.72,37.4-37.423,36.419-69.358-.611-19.844-30.931-41.267-48.933-45.117a30.661,30.661,0,0,0-24.911,5.8c-15.131,12.422-14.487,63.79-30.443,74.527-6.562,4.417-2.191-26.67-6.813-21.629-9.122,9.946-3.272,25.168-1.631,30.979,7.776,27.518,15.922,7.168,23.509,30.666,4.084,12.633-31.941,25.759-50.952,29.34-18.743,3.531-26.822,13.752-16.974,5.566-26.494-11.119,28.6-46.627,31.075-56.691,3.539-14.382-11.156-20.514-14.1-43.2-2.013-15.514-3.428-37.7,2.054-51.925,5.172-13.431,9.664-25.088,21.416-35.659C282.294,17.747,305.079.489,329.24,0c11.123-.223,19.3,14.941,32.192,19.474h0Z"
          transform="translate(462.839 217.703)"
          fill="#090814"
        />
        <path
          d="M562.316,542.2c-.126,0-.252,0-.38-.009a9.051,9.051,0,0,1-7.429-5.025,118.731,118.731,0,0,0-21.971-28.3c-5.156-4.9-10.544-9.459-15.755-13.867-13.442-11.367-26.1-22.073-33.129-36.866-15.321-32.257,2.722-77.185,28.5-97.334,28.912-22.6,66.94-26.143,103.729-26.607q5.735-.072,11.477-.072h0a925.618,925.618,0,0,1,197.621,21.49c21.677,4.756,44.368,10.583,62.6,24.724,18.126,14.057,29.143,36.193,28.068,56.4-1.569,29.493-27.858,51.531-51.8,57.292-22.817,5.487-46.52,1.779-71.614-2.148-5.54-.866-11.268-1.763-16.932-2.542-61.56-8.462-177.2,17.621-182.1,18.735l-4.854,1.105L569.519,538a8.621,8.621,0,0,1-7.2,4.208Z"
          transform="translate(450.801 -107.199)"
          fill="#17376f"
        />
        <g transform="translate(-377.562 -54.635) rotate(-17)">
          <path
            d="M12,15.637a1,1,0,0,1-1-1V9a1,1,0,0,1,2,0v5.637A1,1,0,0,1,12,15.637Z"
            transform="translate(1168 614.363)"
            fill="#090814"
          />
          <path
            d="M12,1.668a2.93,2.93,0,0,1,2.492,1.4l0,0L22.6,16.612l.008.014A2.914,2.914,0,0,1,20.119,21H3.882a2.914,2.914,0,0,1-2.491-4.371l.008-.014L9.489,3.1l.019-.032A2.93,2.93,0,0,1,12,1.668Zm.78,2.438A.914.914,0,0,0,11.23,4.09l-.009.015L3.12,17.631A.914.914,0,0,0,3.9,19H20.1a.914.914,0,0,0,.78-1.365Z"
            transform="translate(1168 615)"
            fill="#090814"
          />
          <path
            d="M12.01,17H12a1,1,0,0,1,0-2h.01a1,1,0,0,1,0,2Z"
            transform="translate(1168 616)"
            fill="#090814"
          />
        </g>
        <g transform="translate(454.737 -914.381) rotate(28)">
          <g transform="translate(1169.002 616.668)">
            <path
              d="M12.394,18.642A1.394,1.394,0,0,1,11,17.249V9.394a1.394,1.394,0,0,1,2.787,0v7.855A1.394,1.394,0,0,1,12.394,18.642Z"
              transform="translate(2.933 -0.063)"
              fill="#090814"
            />
            <path
              d="M16.329,1.668A4.084,4.084,0,0,1,19.8,3.624l0,.006L31.1,22.494l.012.02A4.061,4.061,0,0,1,27.642,28.6H5.015a4.061,4.061,0,0,1-3.471-6.091l.011-.019L12.83,3.669l.026-.044A4.084,4.084,0,0,1,16.329,1.668Zm1.088,3.4a1.274,1.274,0,0,0-2.161-.023l-.012.021L3.953,23.913a1.274,1.274,0,0,0,1.087,1.9H27.617a1.274,1.274,0,0,0,1.087-1.9Z"
              transform="translate(-1.002 -1.668)"
              fill="#090814"
            />
            <path
              d="M12.408,17.787h-.014a1.394,1.394,0,0,1,0-2.787h.014a1.394,1.394,0,0,1,0,2.787Z"
              transform="translate(2.933 4.973)"
              fill="#090814"
            />
          </g>
        </g>
        <g transform="translate(-23.074 -45.527) rotate(-7)">
          <g transform="translate(1169.002 616.668)">
            <path
              d="M12.063,16.117A1.063,1.063,0,0,1,11,15.054V9.063a1.063,1.063,0,0,1,2.126,0v5.991A1.063,1.063,0,0,1,12.063,16.117Z"
              transform="translate(-0.373 -1.946)"
              fill="#090814"
            />
            <path
              d="M12.692,1.668A3.115,3.115,0,0,1,15.341,3.16l0,0L23.96,17.553l.009.015a3.1,3.1,0,0,1-2.648,4.644H4.063a3.1,3.1,0,0,1-2.648-4.646l.009-.015,8.6-14.358.02-.034A3.115,3.115,0,0,1,12.692,1.668Zm.83,2.592a.972.972,0,0,0-1.648-.017l-.009.016L3.253,18.635a.972.972,0,0,0,.829,1.451H21.3a.972.972,0,0,0,.829-1.45Z"
              transform="translate(-1.002 -1.668)"
              fill="#090814"
            />
            <path
              d="M12.074,17.126h-.011a1.063,1.063,0,1,1,0-2.126h.011a1.063,1.063,0,1,1,0,2.126Z"
              transform="translate(-0.373 0.234)"
              fill="#090814"
            />
          </g>
        </g>
        <g transform="translate(-52.001 -343.001)">
          <g transform="translate(1169.002 616.668)">
            <path
              d="M14.346,33.556A3.346,3.346,0,0,1,11,30.209V11.346a3.346,3.346,0,0,1,6.693,0V30.209A3.346,3.346,0,0,1,14.346,33.556Z"
              transform="translate(22.457 11.059)"
              fill="#fff"
            />
            <path
              d="M37.806,1.668a9.806,9.806,0,0,1,8.34,4.7l.009.015,27.126,45.3.028.048a9.751,9.751,0,0,1-8.335,14.622H10.639A9.751,9.751,0,0,1,2.3,51.72l.027-.046L29.4,6.473q.03-.054.062-.107A9.806,9.806,0,0,1,37.806,1.668Zm2.612,8.16a3.059,3.059,0,0,0-5.189-.055l-.03.051L8.089,55.086a3.059,3.059,0,0,0,2.61,4.569H64.913a3.059,3.059,0,0,0,2.609-4.566Z"
              transform="translate(-1.002 -1.668)"
              fill="#fff"
            />
            <path
              d="M14.38,21.693h-.033a3.346,3.346,0,0,1,0-6.693h.033a3.346,3.346,0,1,1,0,6.693Z"
              transform="translate(22.457 32.961)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const IllustrationDataSyncing = (props: IIconProps) => {
  const { className = "", scale = 1, color = "#000", style = {} } = props;
  return (
    <svg
      width={`${scale * 813.04}px`}
      height={`${scale * 683.381}px`}
      viewBox="0 0 813.04 683.381"
      className={className}
      fill={color}
      style={style}
    >
    <path d="M739.66209,833.48708H93.28238c-27.38718,0-49.66852-22.28134-49.66852-49.67V219.36774c0-27.38718,22.28134-49.66852,49.66852-49.66852h646.37972c27.38866,0,49.67,22.28134,49.67,49.66852v564.44933c0,27.38866-22.28134,49.67-49.67,49.67ZM93.28238,172.73368c-25.71437,0-46.63406,20.91969-46.63406,46.63406v564.44933c0,25.71437,20.91969,46.63554,46.63406,46.63554h646.37972c25.71437,0,46.63554-20.92117,46.63554-46.63554V219.36774c0-25.71437-20.92117-46.63406-46.63554-46.63406H93.28238Z" fill="#090814" />
    <path d="M633.05154,719.69635H199.12394c-11.29477,0-20.4826-9.18783-20.4826-20.4826,0-5.46736,2.13212-10.60875,6.00372-14.47887,3.8553-3.8716,8.99818-6.00372,14.47887-6.00372h433.9276c11.29477,0,20.4826,9.18783,20.4826,20.4826,0,5.46736-2.13212,10.61023-6.00224,14.48035-3.85382,3.87012-8.9967,6.00224-14.48035,6.00224Z" fill="#d6d6e3" />
    <path d="M537.46609,699.2145c0,5.44736-2.2151,10.37835-5.77999,13.94325-3.56638,3.56564-8.49737,5.78073-13.94399,5.78073H199.12394c-10.89323,0-19.72398-8.83001-19.72398-19.72398,0-5.44662,2.2151-10.37761,5.78147-13.94325,3.5649-3.58045,8.49589-5.78073,13.94251-5.78073h318.61817c10.89323,0,19.72398,8.83075,19.72398,19.72398Z" fill="#1a3d7c" /><path d="M502.03197,638.5231h-176.42977c-15.3575,0-27.85242-12.49492-27.85242-27.8539v-231.05003c0-15.3575,12.49492-27.85242,27.85242-27.85242l133.30727.7601,70.9764,76.68824v181.45411c0,15.35898-12.49492,27.8539-27.8539,27.8539Z" fill="#d6d6e3" />
    <path d="M414.57644,442.63753h-67.53893c-2.93222,0-5.3103-2.37808-5.3103-5.3103s2.37808-5.3103,5.3103-5.3103h67.53893c2.93222,0,5.3103,2.37808,5.3103,5.3103s-2.37808,5.3103-5.3103,5.3103Z" fill="#090814" />
    <path d="M481.04412,483.00709h-134.74301c-2.93222,0-5.3103-2.37808-5.3103-5.3103s2.37808-5.3103,5.3103-5.3103h134.74301c2.93222,0,5.3103,2.37808,5.3103,5.3103s-2.37808,5.3103-5.3103,5.3103Z" fill="#090814" />
    <path d="M481.04412,520.48592h-134.00662c-2.93222,0-5.3103-2.37808-5.3103-5.3103s2.37808-5.3103,5.3103-5.3103h134.00662c2.93222,0,5.3103,2.37808,5.3103,5.3103s-2.37808,5.3103-5.3103,5.3103Z" fill="#090814" />
    <path d="M380.80771,558.65075h-34.5066c-2.93222,0-5.3103-2.37808-5.3103-5.3103s2.37808-5.3103,5.3103-5.3103h34.5066c2.93222,0,5.3103,2.37808,5.3103,5.3103s-2.37808,5.3103-5.3103,5.3103Z" fill="#090814" />
    <path d="M529.12726,431.03013h-68.71093c-7.70172,0-13.9677-6.26598-13.9677-13.9677v-64.53707h3.03446v64.53707c0,6.02891,4.90433,10.93324,10.93324,10.93324h68.71093v3.03446Z" />
    <path d="M416.11441,658.24708c-13.64025,0-24.73795-11.0977-24.73795-24.73795v-23.81339h-16.74138c-3.49674,0-6.62751-1.9484-8.17289-5.08509s-1.18089-6.80531.94975-9.57751l42.1283-54.79658c1.71133-2.22399,4.30869-3.50267,7.1046-3.45673,2.8048.02667,5.36957,1.33647,7.03645,3.59305l41.1667,55.72855c2.13805,2.8937,2.45957,6.68826.83862,9.902-1.62243,3.21374-4.8658,5.20955-8.46478,5.20955h-16.36948v22.29616c0,13.64025-11.0977,24.73795-24.73795,24.73795Z" fill="#1a3d7c" />
    <circle cx="560.98874" cy="420.8005" r="4.55169" fill="#d6d6e3" />
    <circle cx="581.47134" cy="479.21383" r="4.55169" fill="#d6d6e3" />
    <circle cx="259.81871" cy="436.73141" r="4.55169" fill="#d6d6e3" />
    <circle cx="264.3704" cy="524.73071" r="4.55169" fill="#d6d6e3" />
    <circle cx="259.81871" cy="593.00603" r="4.55169" fill="#d6d6e3" />
    <circle cx="560.23012" cy="593.00603" r="4.55169" fill="#d6d6e3" />
    <circle cx="560.23012" cy="524.73071" r="4.55169" fill="#d6d6e3" />
    <path d="M37.40122,152.42148c-6.44526,0-12.11265-4.61836-13.35132-11.0088L.24984,18.65638c-.76454-3.9442.24448-7.99953,2.76776-11.12585,2.5218-3.12484,6.27191-4.96804,10.28871-5.05397L128.31645.00364c6.71641-.15261,12.40898,4.50872,13.65062,11.06214l22.55693,119.0462c.72898,3.85234-.23855,7.83062-2.65811,10.91694-2.41808,3.08484-6.04966,4.97693-9.96274,5.18881l-113.76701,6.18301c-.24596.01334-.49191.02074-.73491.02074Z" fill="#d6d6e3" />
    <polygon points="29.95846 132.52692 54.99274 65.01021 96.71655 96.11341 110.37162 82.45835 158.16434 131.7683 29.95846 132.52692" fill="#1a3d7c" />
    <path d="M107.33749,58.94148c-6.27487,0-11.37922-5.10435-11.37922-11.37922s5.10435-11.37922,11.37922-11.37922,11.37922,5.10435,11.37922,11.37922-5.10435,11.37922-11.37922,11.37922Z" fill="#1a3d7c" />
    <path d="M41.65954,616.11285c-3.58564,0-7.09275-1.04902-10.16129-3.07891-4.19312-2.77665-7.02163-7.02608-7.96101-11.96596L.5521,480.25267c-1.87135-9.84125,4.31462-19.28244,14.08327-21.49309l102.97009-23.32444c4.88655-1.10384,9.89162-.22077,14.09957,2.48772,4.2109,2.71145,7.08682,6.90606,8.0988,11.8089l25.05355,121.36946c2.04174,9.89014-4.32647,19.67509-14.19439,21.81462l-105.03998,22.76881c-1.31869.28596-2.64626.4282-3.96347.4282Z" fill="#d6d6e3" />
    <path d="M33.74594,507.28424c-2.50698,0-4.7369-1.78245-5.21399-4.33685-.53933-2.88333,1.36165-5.65701,4.24498-6.19486l83.24611-15.5516c2.88185-.54674,5.65553,1.36165,6.19486,4.24498s-1.36165,5.65701-4.24498,6.19486l-83.24611,15.5516c-.32893.06223-.65786.09186-.98087.09186Z" fill="#090814" />
    <path d="M41.33357,539.14606c-2.40327,0-4.57984-1.64169-5.16214-4.082-.6786-2.85221,1.0831-5.71628,3.9368-6.39637l78.36253-18.65866c2.85073-.67564,5.7148,1.0831,6.39637,3.9368.6786,2.85221-1.0831,5.71628-3.9368,6.39637l-78.36253,18.65866c-.41339.09779-.82677.1452-1.23423.1452Z" fill="#090814" />
    <path d="M46.64239,569.97367c-2.45513,0-4.65985-1.71281-5.18881-4.2109-.60748-2.86999,1.22534-5.68813,4.09385-6.29561l53.46159-11.32144c2.88481-.606,5.68961,1.22534,6.29561,4.09385.60748,2.86999-1.22534,5.68813-4.09385,6.29561l-53.46159,11.32144c-.3719.07853-.74232.11705-1.10681.11705Z" fill="#090814" />
    <path d="M816.49406,244.42277c-.94382,0-1.89802-.07408-2.85666-.22373l-106.17939-16.65841c-4.96952-.78084-9.30785-3.46859-12.21785-7.57133-2.91-4.10126-4.01384-9.0856-3.10854-14.03141l22.15096-120.97089c1.80764-9.8531,10.97472-16.41097,20.89006-14.96634l104.45028,15.39603c4.95322.73046,9.30488,3.36191,12.25192,7.40983,2.94852,4.04644,4.11756,8.99521,3.29227,13.93362l-20.42185,122.23475c-1.50241,9.00262-9.38341,15.44788-18.2512,15.44788Z" fill="#d6d6e3" />
    <path d="M820.66792,138.04188c-.323,0-.65045-.02963-.97938-.09186l-83.25204-15.52938c-2.88333-.53785-4.78431-3.31005-4.24646-6.19338.53636-2.88333,3.30264-4.79616,6.19338-4.24646l83.25204,15.52938c2.88333.53785,4.78431,3.31005,4.24646,6.19338-.47562,2.5544-2.70701,4.33833-5.21399,4.33833Z" fill="#090814" />
    <path d="M812.81507,165.83355c-.24003,0-.48006-.01482-.72454-.0489l-79.81753-10.86953c-2.90555-.39561-4.93989-3.0715-4.54428-5.97854.39709-2.90704,3.08187-4.94285,5.97854-4.54428l79.81753,10.86953c2.90555.39561,4.93989,3.0715,4.54428,5.97854-.36301,2.66256-2.64033,4.59317-5.254,4.59317Z" fill="#090814" />
    <path d="M780.77249,194.36309c-.28152,0-.56748-.02371-.85492-.06964l-53.9461-8.73c-2.89518-.46821-4.86136-3.19596-4.39315-6.09114.46969-2.89518,3.17818-4.85543,6.09114-4.39315l53.9461,8.73c2.89518.46821,4.86136,3.19596,4.39315,6.09114-.42228,2.60774-2.67589,4.46279-5.23622,4.46279Z" fill="#090814" />
    </svg>)
}